import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import {
  getInitialLanguage,
  normalizeLanguage,
  setDocumentLanguage,
} from '@/shared/lib/language/language'
import { absenceTranslations } from './absenceTranslations'
import { acceptInviteTranslations } from './acceptInviteTranslations'
import { agreementTemplateTranslations } from './agreementTemplateTranslations'
import { agreementTranslations } from './agreementTranslations'
import { applicationTranslations } from './applicationTranslations'
import { diaryEntryTranslations } from './diaryEntryTranslations'
import { diaryTranslations } from './diaryTranslations'
import { educationalRegistrationTranslations } from './educationalRegistrationTranslations'
import { eduInternDetailsTranslations } from './eduInternDetailsTranslations'
import { eduInternTranslations } from './eduInternTranslations'
import { edyEduOrganizationsTranslations } from './edyEduOrganizationsTranslations'
import { edyOrganizationsTranslations } from './edyOrganizationsTranslations'
import { edyStatisticsTranslations } from './edyStatisticsTranslations'
import { edySupportCasesTranslations } from './edySupportCasesTranslations'
import { futureInternshipTranslations } from './futureInternshipTranslations'
import { institutionProfileTranslations } from './institutionProfileTranslations'
import { internAgreementTranslations } from './internAgreementTranslations'
import { internDetailsTranslations } from './internDetailsTranslations'
import { internshipActionTranslations } from './internshipActionTranslations'
import { internshipDetailsTranslations } from './internshipDetailsTranslations'
import { internshipFilterTranslations } from './internshipFilterTranslations'
import { internshipHubTranslations } from './internshipHubTranslations'
import { internVacancyTranslations } from './internVacancyTranslations'
import { myApplicationTranslations } from './myApplicationTranslations'
import { myCvTranslations } from './myCvTranslations'
import { myEduInternTranslations } from './myEduInternTranslations'
import { myOrgInternTranslations } from './myOrgInternTranslations'
import { myProfileTranslations } from './myProfileTranslations'
import { orgAgreementTranslations } from './orgAgreementTranslations'
import { organizationProfileTranslations } from './organizationProfileTranslations'
import { organizationRegistrationTranslations } from './organizationRegistrationTranslations'
import { eduDiaryTranslations, orgDiaryTranslations } from './orgDiaryTranslations'
import { orgInternTranslations } from './orgInternTranslations'
import { paymentTranslations } from './paymentTranslations'
import { registrationTranslations } from './registrationTranslations'
import { savedDeviceTranslations } from './savedDeviceTranslations'
import { sessionGateTranslations } from './sessionGateTranslations'
import { termsTranslations } from './termsTranslations'
import { vacancyTranslations } from './vacancyTranslations'

const resources = {
  lv: {
    translation: {
      registration: registrationTranslations.lv,
      acceptInvite: acceptInviteTranslations.lv,
      sessionGate: sessionGateTranslations.lv,
      educationalRegistration: educationalRegistrationTranslations.lv,
      myProfile: myProfileTranslations.lv,
      myCv: myCvTranslations.lv,
      terms: termsTranslations.lv,
      institutionProfile: institutionProfileTranslations.lv,
      organizationProfile: organizationProfileTranslations.lv,
      organizationRegistration: organizationRegistrationTranslations.lv,
      payments: paymentTranslations.lv,
      edyStatistics: edyStatisticsTranslations.lv,
      edySupportCases: edySupportCasesTranslations.lv,
      edyOrganizations: edyOrganizationsTranslations.lv,
      edyEduOrganizations: edyEduOrganizationsTranslations.lv,
      savedDevices: savedDeviceTranslations.lv,
      vacancies: vacancyTranslations.lv,
      myOrgInterns: myOrgInternTranslations.lv,
      myEduInterns: myEduInternTranslations.lv,
      orgInterns: orgInternTranslations.lv,
      orgDiary: orgDiaryTranslations.lv,
      eduDiary: eduDiaryTranslations.lv,
      eduInternDetails: eduInternDetailsTranslations.lv,
      eduInterns: eduInternTranslations.lv,
      internshipDetails: internshipDetailsTranslations.lv,
      internDetails: internDetailsTranslations.lv,
      futureInternships: futureInternshipTranslations.lv,
      applications: applicationTranslations.lv,
      absence: absenceTranslations.lv,
      diary: diaryTranslations.lv,
      diaryEntry: diaryEntryTranslations.lv,
      internshipHub: internshipHubTranslations.lv,
      agreements: agreementTranslations.lv,
      orgAgreements: orgAgreementTranslations.lv,
      internAgreements: internAgreementTranslations.lv,
      internVacancies: internVacancyTranslations.lv,
      myApplications: myApplicationTranslations.lv,
      agreementTemplates: agreementTemplateTranslations.lv,
      internshipActions: internshipActionTranslations.lv,
      internshipFilters: internshipFilterTranslations.lv,
      common: {
        yes: 'Jā',
        no: 'Nē',
        close: 'Aizvērt',
        cancel: 'Atcelt',
        back: 'Atpakaļ',
        unexpectedError: 'Neizdevās ielādēt datus',
        retry: 'Mēģināt vēlreiz',
        actionsLoading: 'Ielādē darbības',
        actionsLoadFailed: 'Neizdevās ielādēt darbības',
        noActions: 'Nav pieejamu darbību',
      },
      navigation: {
        sidebar: 'Galvenā navigācija',
        mobile: 'Mobilā navigācija',
        more: 'Vairāk',
        moreMenu: 'Vairāk sadaļu',
        sections: 'Sadaļas',
        collapseSidebar: 'Sakļaut izvēlni',
        expandSidebar: 'Izvērst izvēlni',
        mobilePages: {
          emailManagement: 'E-pasti',
        },
        groups: {
          internships: 'Prakšu norise',
          internshipDocuments: 'Prakses dokumenti',
          students: 'Studentu reģistrs',
          templates: 'Sagataves',
          workplaces: 'Prakses vietas',
          recruitment: 'Praktikantu piesaiste',
          administration: 'Administrācija',
        },
        pages: {
          users: 'Lietotāji',
          educationalInstitutions: 'Izglītības iestādes',
          workplaces: 'Prakses vietas',
          statistics: 'Statistika',
          finances: 'Finanses',
          support: 'Atbalsts',
          emailManagement: 'E-pastu pārvaldība',
          students: 'Studenti',
          internships: 'Prakses',
          interns: 'Praktikanti',
          programs: 'Programmas',
          surveys: 'Noslēguma anketas',
          agreements: 'Līgumi',
          agreementTemplates: 'Līgumu sagataves',
          internshipHub: 'Prakšu centrāle',
          diary: 'Dienasgrāmata',
          internshipProgram: 'Prakses programma',
          absence: 'Prombūtne',
          myWorkplace: 'Mana prakses vieta',
          vacancySearch: 'Vakances',
          myApplications: 'Mani pieteikumi',
          myProfile: 'Mans profils',
          savedDevices: 'Saglabātās ierīces',
          myCv: 'Mans CV',
          institutionProfile: 'Iestādes profils',
          institutionUsers: 'Iestādes lietotāji',
          workplaceProfile: 'Organizācijas profils',
          createOrganization: 'Izveidot organizāciju',
          workplaceUsers: 'Prakses vietas lietotāji',
          platformMembers: 'Edy365 lietotāji',
          payments: 'Maksājumi',
        },
      },
      pagination: {
        first: 'Pirmā lapa',
        previous: 'Iepriekšējā lapa',
        next: 'Nākamā lapa',
        last: 'Pēdējā lapa',
      },
      dataTable: {
        search: 'Meklēt',
        clearSearch: 'Notīrīt meklēšanu',
        columns: 'Kolonnas',
        visibleColumns: 'Rādāmās kolonnas',
        enableAllColumns: 'Ieslēgt visas',
        resetColumns: 'Atiestatīt',
        done: 'Gatavs',
        resizeColumn: 'Mainīt kolonnas “{{column}}” platumu',
        pageSize: 'Ierakstu skaits lapā',
        rowsPerPage: '{{count}} / lapā',
        range: 'Rāda {{from}}–{{to}} no {{total}}',
      },
      session: {
        signIn: 'Pieslēgties',
        signInDescription: 'Pieslēdzieties, lai turpinātu darbu edy365.',
        signInErrorTitle: 'Neizdevās pieslēgties',
        signInError: 'Pārbaudiet e-pastu un paroli un mēģiniet vēlreiz.',
        loginCode: 'Pieteikšanās kods',
        codeSentTo: 'Kods nosūtīts uz {{email}}.',
        codeValidity: 'Kods ir derīgs 10 minūtes.',
        code: 'Kods',
        codeRequired: 'Ievadiet pieteikšanās kodu',
        rememberDevice: 'Atcerēties šo pārlūku 60 dienas',
        verifyCode: 'Apstiprināt',
        resendCode: 'Sūtīt kodu vēlreiz',
        codeResent: 'Jauns kods nosūtīts.',
        codeVerificationError:
          'Neizdevās apstiprināt kodu. Mēģiniet vēlreiz vai atgriezieties pie pieteikšanās.',
        codeResendError:
          'Neizdevās nosūtīt kodu. Mēģiniet vēlreiz vai atgriezieties pie pieteikšanās.',
        signOut: 'Izrakstīties',
        email: 'E-pasts',
        emailRequired: 'Ievadiet e-pasta adresi',
        emailInvalid: 'Ievadiet derīgu e-pasta adresi',
        password: 'Parole',
        passwordRequired: 'Ievadiet paroli',
        passwordInvalid: 'Parole ir pārāk gara',
        passwordVisibility: 'Rādīt vai paslēpt paroli',
        restoring: 'Atjauno sesiju…',
        language: 'Valoda',
        forgotPassword: 'Aizmirsi paroli?',
        forgotPasswordDescription:
          'Ievadiet sava konta e-pastu, un mēs nosūtīsim drošu paroles atiestatīšanas saiti.',
        forgotPasswordErrorTitle: 'Neizdevās nosūtīt saiti',
        forgotPasswordError: 'Pārbaudiet interneta savienojumu un mēģiniet vēlreiz.',
        resetPassword: 'Atiestatīt paroli',
        resetPasswordDescription: 'Izvēlieties jaunu paroli savam edy365 kontam.',
        resetPasswordErrorTitle: 'Neizdevās atiestatīt paroli',
        sendResetLink: 'Sūtīt saiti',
        resetLinkSentTitle: 'Pārbaudiet savu e-pastu',
        resetLinkSentDescription: 'Norādījumi nosūtīti uz jūsu e-pasta adresi.',
        resetLinkSent:
          'Ja konts ar šādu e-pastu pastāv, uz to tika nosūtīta paroles atiestatīšanas saite.',
        backToLogin: 'Atgriezties pie pieteikšanās',
        newPassword: 'Jauna parole',
        newPasswordRequired: 'Ievadiet jauno paroli',
        repeatPassword: 'Atkārtojiet paroli',
        repeatPasswordRequired: 'Atkārtojiet jauno paroli',
        passwordRequirements:
          'Izmantojiet vismaz 8 rakstzīmes, tostarp lielo burtu, mazo burtu un ciparu.',
        invalidTokenTitle: 'Saite nav derīga',
        invalidToken: 'Šī atiestatīšanas saite ir nederīga vai beigusies. Lūdzu, pieprasiet jaunu.',
        requestNewResetLink: 'Pieprasīt jaunu saiti',
        passwordsDoNotMatch: 'Paroles nesakrīt',
        passwordChangeRequired: 'Lai turpinātu, nomainiet savu paroli.',
        termsAcceptanceTitle: 'Lietošanas noteikumi',
        termsAcceptanceRequired:
          'Lai turpinātu, apstipriniet piekrišanu lietošanas noteikumiem un personas datu apstrādes noteikumiem.',
        termsRequired: 'Lai turpinātu, jāpiekrīt lietošanas noteikumiem',
        dataPolicyRequired: 'Lai turpinātu, jāpiekrīt personas datu apstrādes noteikumiem',
        acceptTermsAndContinue: 'Piekrist un turpināt',
        termsAcceptanceError: 'Neizdevās saglabāt piekrišanu. Mēģiniet vēlreiz.',
      },
      supportSession: {
        caseBadge: 'Lieta {{caseNumber}}',
        startTitle: 'Sākt atbalsta sesiju',
        startWarning:
          'Jūs strādāsiet šī lietotāja vārdā. Darbība tiks reģistrēta norādītajā atbalsta lietā.',
        representedUser: 'Pārstāvētais lietotājs',
        caseNumber: 'Lietas Nr.',
        caseNumberRequired: 'Ievadiet atbalsta lietas numuru',
        start: 'Sākt atbalsta sesiju',
        startError: 'Neizdevās sākt atbalsta sesiju',
        logs: 'Žurnāli',
        noLogs: 'Žurnāla ieraksti nav atrasti.',
        return: 'Atgriezties administratora sesijā',
        returnErrorTitle: 'Neizdevās atjaunot administratora sesiju',
        returnError: 'Atbalsta sesija paliek aktīva. Mēģiniet vēlreiz.',
        summaryTitle: 'Pieslēgšanās šķēršļi — {{user}}',
        summaryHint:
          'Ko lietotājs sastaps, pieslēdzoties pats. Atbalsta sesijā tie netiek piemēroti.',
        noBlockers: 'Šķēršļu nav',
        lockedUntil: 'līdz {{date}}',
        noTrustedDevices: 'nav saglabātu ierīču',
        exceptTrustedDevices_zero: 'izņemot {{count}} saglabātās ierīces',
        exceptTrustedDevices_one: 'izņemot {{count}} saglabāto ierīci',
        exceptTrustedDevices_other: 'izņemot {{count}} saglabātās ierīces',
        blockers: {
          LockedOut: 'Konts bloķēts',
          LoginCodeRequired: 'Jāievada pieteikšanās kods no e-pasta',
          MustChangePassword: 'Jāmaina parole',
          MustChangeEmail: 'Jāmaina e-pasts',
          MustAcceptUserTerms: 'Jāapstiprina lietošanas noteikumi',
          MustAcceptUserDataPolicy: 'Jāapstiprina datu politika',
          MustAcceptOrgTerms: 'Organizācijai jāapstiprina noteikumi',
          MustAcceptOrgDataPolicy: 'Organizācijai jāapstiprina datu politika',
          ConfirmInternDetails: 'Jāapstiprina praktikanta dati',
          ConfirmAgreementDetails: 'Jāapstiprina līguma dati',
        },
        logKinds: {
          userLogs: 'Lietotāja žurnāls',
          internLogs: 'Prakses žurnāls',
          eduLogs: 'Izglītības iestādes žurnāls',
          orgLogs: 'Prakses vietas žurnāls',
        },
        logColumns: {
          date: 'Datums',
          action: 'Darbība',
          actor: 'Lietotājs',
          context: 'Konteksts',
          ip: 'IP adrese',
        },
      },
      profileMenu: {
        myData: 'Mani dati',
        institutionSettings: 'Iestādes iestatījumi',
        workplaceSettings: 'Prakses vietas iestatījumi',
        platformSettings: 'Edy365 iestatījumi',
        signOut: 'Iziet',
        roles: {
          institution: {
            user: 'Lietotājs',
            manager: 'Pārvaldnieks',
            admin: 'Administrators',
            support: 'Atbalsts',
          },
          workplace: {
            user: 'Lietotājs',
            manager: 'Pārvaldnieks',
            admin: 'Administrators',
            support: 'Atbalsts',
          },
          platform: {
            user: 'Lietotājs',
            manager: 'Pārvaldnieks',
            admin: 'Administrators',
            support: 'Atbalsts',
          },
        },
      },
      roleSwitcher: {
        currentSection: 'Šis konts darbojas kā',
        switchSection: 'Pārslēgties uz',
        contextType: {
          Org: 'Prakses vieta',
          Edu: 'Izglītības iestāde',
          Intern: 'Praktikants',
          Edy365: 'Edy365',
          Student: 'Students',
        },
        explanation:
          'Katrs konteksts ir atsevišķa darba vide. Izvēlne, dati un tiesības mainās kopā ar to. Vienlaikus var būt tikai viens aktīvs.',
        errorTitle: 'Neizdevās pārslēgt lomu',
        errorMessage: 'Mēģiniet vēlreiz vai atjaunojiet lapu.',
      },
      internshipSwitcher: {
        label: 'Manas prakses',
        status: {
          upcoming: 'gaidāma',
          ongoing: 'notiek',
          ended: 'beigusies',
        },
        explanation:
          'Praksi pievieno un noņem izglītības iestāde. Beigušos praksi var skatīt, bet ne labot.',
        errorTitle: 'Neizdevās pārslēgt praksi',
        errorMessage: 'Mēģiniet vēlreiz vai atjaunojiet lapu.',
      },
      notifications: {
        title: 'Paziņojumi',
        newCount_one: '{{count}} jauns',
        newCount_other: '{{count}} jauni',
        attentionSection: 'Nepieciešama darbība',
        noticeSection: 'Jauni paziņojumi',
        markNoticesRead: 'Atzīmēt paziņojumus kā izlasītus',
        empty: 'Jaunu paziņojumu nav',
        loadErrorTitle: 'Neizdevās ielādēt paziņojumus',
        loadErrorMessage: 'Pārbaudiet savienojumu un mēģiniet vēlreiz.',
        openErrorTitle: 'Neizdevās atvērt paziņojumu',
        openErrorMessage: 'Lomu nevarēja pārslēgt vai paziņojums vairs nav pieejams.',
        markReadErrorTitle: 'Neizdevās atzīmēt paziņojumus',
        markReadErrorMessage: 'Mēģiniet vēlreiz.',
        invite: {
          accept: 'Pieņemt',
          decline: 'Noraidīt',
          declineConfirm:
            'Noraidīt uzaicinājumu? Tas tiks dzēsts — lai pievienotos vēlāk, administratoram jāsūta jauns.',
          confirmDecline: 'Noraidīt uzaicinājumu',
          accepted: 'Uzaicinājums pieņemts',
          declined: 'Uzaicinājums noraidīts',
          acceptErrorTitle: 'Neizdevās pieņemt uzaicinājumu',
          declineErrorTitle: 'Neizdevās noraidīt uzaicinājumu',
          errorMessage: 'Mēģiniet vēlreiz.',
        },
        events: {
          fallback: 'Jauns paziņojums',
          ProcessInternApplication_one: '{{count}} prakses pieteikums gaida izskatīšanu',
          ProcessInternApplication_other: '{{count}} prakses pieteikumi gaida izskatīšanu',
          SignAgreement_one: '{{count}} līgums gaida parakstu',
          SignAgreement_other: '{{count}} līgumi gaida parakstu',
          AcceptUser_one: '{{count}} lietotāja pievienošana gaida apstiprinājumu',
          AcceptUser_other: '{{count}} lietotāju pievienošanas gaida apstiprinājumu',
          AcceptOrgInvite: 'Uzaicinājums pievienoties organizācijai',
          UnratedRecords_one: '{{count}} ieraksts gaida vērtējumu',
          UnratedRecords_other: '{{count}} ieraksti gaida vērtējumu',
          InternAcceptedElsewhere: 'Praktikants ir pieņemts citā prakses vietā',
          InviteAccepted: 'Uzaicinājums ir pieņemts',
          InviteAcceptedNamed:
            'Lietotājs <strong>{{name}}</strong> pievienojās <strong>{{organization}}</strong>',
          InviteDeclined: 'Uzaicinājums ir noraidīts',
          OrgInviteWithdrawn: 'Organizācijas uzaicinājums ir atsaukts',
          OrgInviteExpired: 'Organizācijas uzaicinājumam beidzies termiņš',
          JoinedOrg: 'Jūs esat pievienots organizācijai',
          JoinedEduAsStudent: 'Jūs esat pievienots izglītības iestādei',
          IndividualRoleAdded: 'Jums ir piešķirta jauna individuālā loma',
          OrgRoleAdded: 'Jums ir piešķirta jauna organizācijas loma',
          OrgRoleRemoved: 'Jūsu organizācijas loma ir noņemta',
          RemovedFromOrg: 'Jūs esat noņemts no organizācijas',
          RemovedFromOrgNamed: 'Jūs esat noņemts no <strong>{{organization}}</strong>',
          AddedToInternship: 'Jūs esat pievienots praksei',
          MovedToAnotherGroup: 'Jūs esat pārcelts uz citu grupu',
          InternRevokedByEdu: 'Izglītības iestāde ir atsaukusi jūsu praksi',
          StudentDataEditedByEdu: 'Izglītības iestāde ir mainījusi jūsu datus',
          PasswordResetByEdu: 'Izglītības iestāde ir atiestatījusi jūsu paroli',
          InternshipDatesChangedByEdu: 'Izglītības iestāde ir mainījusi jūsu prakses datumus',
          InternAssignedByEdu: 'Izglītības iestāde jums ir piešķīrusi praktikantu',
          ProcessEduGoLiveRequest_zero: '{{count}} piekļuves pieprasījumu gaida lēmumu',
          ProcessEduGoLiveRequest_one: '{{count}} piekļuves pieprasījums gaida lēmumu',
          ProcessEduGoLiveRequest_other: '{{count}} piekļuves pieprasījumi gaida lēmumu',
          EduGoLiveDeclined: 'Aktivizācijas pieprasījums noraidīts',
        },
      },
      students: {
        title: 'Studenti',
        breadcrumb: 'Studentu reģistrs',
        description:
          'Students tiek izveidots tikai vienu reizi. Kad students ir reģistrā, viņa grupu var pievienot jebkurai jaunai praksei.',
        count: '{{count}} studenti',
        views: {
          list: 'Visi studenti',
          structure: 'Pēc struktūras',
        },
        structure: {
          navigationTitle: 'Specialitāte → grupa → studenti',
          allGroups: 'Visas grupas',
          studentCount: '{{count}} studenti',
          empty: 'Struktūrā nav aktīvu studentu.',
          actions: {
            addClass: 'Pievienot specialitāti',
            addGroup: 'Pievienot grupu',
            editClass: 'Rediģēt specialitāti',
            editGroup: 'Rediģēt grupu',
            save: 'Saglabāt izmaiņas',
          },
          class: {
            createTitle: 'Pievienot specialitāti',
            editTitle: 'Rediģēt specialitāti',
            title: 'Nosaukums',
            notes: 'Piezīmes',
            active: 'Aktīva',
            createIntro:
              'Specialitāte ir struktūras augstākais līmenis. Grupas un studenti tiek piesaistīti tai zemākajā līmenī.',
            editIntro:
              'Specialitātes nosaukums un piezīmes tiek izmantoti studentu struktūrā un saistītajos sarakstos.',
            create: 'Pievienot specialitāti',
            created: 'Specialitāte pievienota',
            updated: 'Specialitātes izmaiņas saglabātas',
          },
          group: {
            createTitle: 'Pievienot grupu',
            editTitle: 'Rediģēt grupu',
            class: 'Specialitāte',
            chooseClass: 'Izvēlieties specialitāti',
            title: 'Grupas nosaukums',
            year: 'Gads',
            description: 'Apraksts',
            active: 'Aktīva',
            createIntro:
              'Grupa pieder vienai specialitātei. Studentu prakses var piesaistīt visai grupai.',
            editIntro:
              'Grupas specialitāti nevar mainīt šajā formā. Lai mainītu nosaukumu vai gadu, saglabājiet izmaiņas šeit.',
            create: 'Pievienot grupu',
            created: 'Grupa pievienota',
            updated: 'Grupas izmaiņas saglabātas',
            loadError: 'Grupas dati nebija pieejami. Mēģiniet vēlreiz.',
          },
          validation: {
            classTitle: 'Ievadiet specialitātes nosaukumu',
            groupClass: 'Izvēlieties specialitāti',
            groupTitle: 'Ievadiet grupas nosaukumu',
            groupYear: 'Ievadiet derīgu gadu',
          },
        },
        pageSize: 'Studentu skaits lapā',
        add: 'Pievienot studentu',
        search: 'Meklēt pēc vārda, e-pasta vai personas koda…',
        specialty: 'Specialitāte',
        group: 'Grupa',
        status: 'Statuss',
        admissionYear: 'Uzņemšanas gads',
        all: 'Visi',
        noPlacement: 'Nav praksē',
        activePlacement: 'Praksē',
        archived: 'Arhivēts',
        currentPlacement: 'Pašreizējā prakse',
        personalCode: 'Personas kods',
        phone: 'Tālrunis',
        email: 'E-pasts',
        firstName: 'Vārds',
        lastName: 'Uzvārds',
        invitation: 'Nosūtīt uzaicinājumu uz e-pastu',
        invitationLanguage: 'Uzaicinājuma valoda',
        save: 'Pievienot studentu',
        cancel: 'Atcelt',
        created: 'Students pievienots',
        empty: 'Studenti nav atrasti',
        actions: 'Studenta darbības',
        edit: 'Rediģēt studentu',
        moveGroup: 'Pārcelt uz citu grupu',
        history: 'Skatīt prakšu vēsturi',
        archive: 'Arhivēt studentu',
        columns: {
          name: 'Uzvārds, vārds',
          group: 'Grupa',
          specialty: 'Specialitāte',
          personalCode: 'Personas kods',
          phone: 'Tālrunis',
          status: 'Statuss',
          currentInternship: 'Pašreizējā prakse',
          actions: 'Studenta darbības',
        },
        filters: {
          button: 'Filtri',
          title: 'Studentu filtri',
          class: 'Specialitāte',
          group: 'Grupa',
          year: 'Uzņemšanas gads',
          all: 'Visi',
          clear: 'Notīrīt',
          apply: 'Pielietot',
          active: 'Aktīvie filtri',
          remove: 'Noņemt filtru “{{filter}}”',
        },
        statuses: {
          All: 'Visi',
          InInternship: 'Praksē līdz {{date}}',
          InInternshipShort: 'Praksē',
          WithFutureInternships: 'Prakse sākas {{date}}',
          WithFutureInternshipsShort: 'Gaidāma prakse',
          WithPastInternships: 'Prakse beigusies {{date}}',
          WithPastInternshipsShort: 'Pabeigta prakse',
          WithNoInternship: 'Nav praksē',
        },
        rowActions: {
          edit: 'Rediģēt studentu',
          move: 'Pārcelt uz citu grupu',
          resetPWD: 'Atiestatīt paroli',
          openHistory: 'Skatīt prakšu vēsturi',
        },
        validation: {
          firstName: 'Ievadiet vārdu',
          lastName: 'Ievadiet uzvārdu',
          email: 'Ievadiet derīgu e-pasta adresi',
          personalCode: 'Ievadiet personas kodu',
          group: 'Izvēlieties grupu',
        },
        create: {
          title: 'Pievienot studentu',
          chooseGroup: 'Izvēlieties grupu',
          language: 'Uzaicinājuma valoda',
          submit: 'Pievienot studentu',
          created: 'Students pievienots. Aktīvām praksēm pievienots: {{count}}.',
          linked: 'Students piesaistīts. Aktīvām praksēm pievienots: {{count}}.',
        },
        editStudent: {
          title: 'Rediģēt studentu',
          save: 'Saglabāt izmaiņas',
          updated: 'Studenta dati saglabāti',
        },
        moveStudent: {
          title: 'Pārcelt uz citu grupu',
          review: 'Pārskatīt pārcelšanu',
          confirm: 'Apstiprināt pārcelšanu',
          back: 'Atpakaļ',
          currentGroup: 'Pašreizējā grupa',
          destinationGroup: 'Jaunā grupa',
          chooseGroup: 'Izvēlieties jauno grupu',
          noCurrentGroup: 'Nav piešķirta grupa',
          warning:
            'Pārcelšana var mainīt studenta prakses: prakses ar dienasgrāmatas ierakstiem var tikt pabeigtas šodien, nākamās prakses un līgumi var tikt dzēsti.',
          confirmTitle: 'Pārcelšanas sekas',
          confirmText: 'Students tiks pārcelts uz grupu “{{group}}”. Vai turpināt?',
          updated:
            'Students pārcelts. Pabeigtas prakses: {{endedInternships}}; dzēstas prakses: {{deletedInternships}}; dzēsti līgumi: {{deletedAgreements}}; pievienotas prakses: {{joinedInternships}}.',
          validation: { group: 'Izvēlieties citu grupu' },
        },
        resetPassword: {
          title: 'Atiestatīt studenta paroli',
          review: 'Pārskatīt atiestatīšanu',
          confirm: 'Atiestatīt paroli',
          back: 'Atpakaļ',
          warning:
            'Tiks izveidota jauna parole un nosūtīta uz {{email}}. Esošās sesijas tiks slēgtas, un students nākamajā pieslēgšanās reizē paroli nomainīs.',
          confirmTitle: 'Paroles atiestatīšanas sekas',
          confirmText:
            'Studentam {{name}} tiks izveidota jauna parole. Esošā parole vairs nedarbosies, un atvērtās sesijas tiks slēgtas. Vai turpināt?',
          successTitle: 'Parole atiestatīta',
          successText: 'Jaunā parole nosūtīta uz {{email}}.',
          generatedPassword: 'Ģenerētā parole',
          changeOnNextSignIn: 'Students šo paroli nomainīs nākamajā pieslēgšanās reizē.',
          copy: 'Kopēt paroli',
          copied: 'Parole nokopēta',
        },
        internshipHistory: {
          title: 'Prakšu vēsture',
          description:
            'Visas prakses, kurās students ir bijis. Dati saglabājas arī pēc arhivēšanas un ir pieejami lasīšanai.',
          empty: 'Studentam nav prakšu vēstures.',
          error: 'Neizdevās ielādēt prakšu vēsturi',
          retry: 'Mēģināt vēlreiz',
          columns: {
            internship: 'Prakse',
            period: 'Periods',
            place: 'Prakses vieta',
            hours: 'Stundas',
            averageGrade: 'Vidējā atzīme',
          },
          grades: {
            notGraded: '—',
            credited: 'Ieskaitīts',
            notCredited: 'Neieskaitīts',
          },
        },
        import: {
          action: 'Importēt no datnes',
          title: 'Importēt studentus no datnes',
          instructions:
            'Vienā reizē var importēt visu grupu. Ja students jau ir reģistrā, sistēma to atpazīs pēc personas koda un nedublēs.',
          file: 'Datne',
          chooseFile: 'Izvēlieties XLSX datni',
          fileDescription:
            'Izmantojiet standarta veidni, kas satur vārdu, uzvārdu, personas kodu, e-pastu un grupu.',
          class: 'Specialitāte',
          chooseClass: 'Izvēlieties specialitāti',
          year: 'Grupas gads',
          chooseYear: 'Izvēlieties gadu',
          language: 'Jauno kontu valoda',
          languageDescription: 'Šo valodu izmantos kontiem, kas tiks izveidoti importēšanas laikā.',
          preview: 'Priekšskatīt',
          previewTitle: 'Pārbaudiet importējamos studentus',
          previewDescription: '{{className}}, grupu gads {{year}}',
          errorRows:
            'Kļūdainās rindas nevar importēt. Izlabojiet datni un veiciet priekšskatījumu vēlreiz.',
          selectAll: 'Atlasīt visas importējamās rindas',
          selectRow: 'Atlasīt {{name}}',
          status: 'Statuss',
          message: 'Paskaidrojums',
          back: 'Atpakaļ',
          submit: 'Importēt {{count}}',
          completed: 'Imports pabeigts',
          completedDescription: 'Apstrādātas {{count}} atlasītās rindas.',
          rejectedRows: 'Noraidītās rindas',
          validation: {
            fileType: 'Izvēlieties XLSX datni.',
            fileSize: 'Datne nedrīkst būt lielāka par 2 MB.',
          },
          counts: {
            new: 'Jauni: {{count}}',
            moved: 'Pārcelti: {{count}}',
            unchanged: 'Nemainīti: {{count}}',
            errors: 'Kļūdas: {{count}}',
            created: 'Izveidoti konti',
            linked: 'Piesaistīti konti',
          },
          statuses: {
            New: 'Jauns',
            Moved: 'Pārcelts',
            Unchanged: 'Nemainīts',
            Error: 'Kļūda',
            Created: 'Izveidots',
            Linked: 'Piesaistīts',
          },
        },
      },
      internshipProgram: {
        title: 'Prakses programma',
        summary: '{{count}} plāna punkti · {{hours}} h',
        description:
          'Programmu izveidoja izglītības iestāde. Katram punktam ir savs stundu apjoms un savs vērtētājs. Pievienojot dienasgrāmatas ierakstu, jūs izvēlaties, uz kuru punktu tas attiecas.',
        search: 'Meklēt punktu…',
        empty: 'Šai praksei nav programmas punktu',
        emptyFiltered: 'Nav atrasts neviens atbilstošs plāna punkts',
        total: 'Kopā',
        progressLabel: 'Izpilde: {{value}}',
        columns: {
          title: 'Plāna punkts',
          planned: 'Plānotās',
          done: 'Nostrādātās',
          left: 'Atlikušās',
          grader: 'Kurš vērtē',
          progress: 'Izpilde',
        },
        graders: {
          Org: 'Prakses vieta',
          Edu: 'Izglītības iestāde',
          None: '—',
        },
        filters: {
          button: 'Filtri',
          title: 'Filtrēt plāna punktus',
          showOnly: 'Rādīt tikai',
          graded: 'Novērtētie',
          hasRecords: 'Ir ieraksti',
          notDone: 'Nav pabeigti',
          clear: 'Notīrīt',
          apply: 'Filtrēt',
          active: 'Aktīvie filtri',
          remove: 'Noņemt filtru “{{filter}}”',
        },
      },
      internshipPlace: {
        title: 'Mana prakses vieta',
        eyebrow: 'Prakses pārskats',
        description:
          'Pārskatiet savu pašreizējo prakses vietu, sazinieties ar vadītāju un apskatiet prakšu vēsturi.',
        placeCount_one: '{{count}} prakses vieta',
        placeCount_other: '{{count}} prakses vietas',
        currentCardLabel: 'Aktīvā prakses vieta',
        historySection: 'Prakses vēsture',
        otherSection: 'Citas prakses vietas',
        contact: 'Kontaktpersona',
        currentStatus: 'Notiek šobrīd',
        status: {
          upcoming: 'Gaidāma',
          ongoing: 'Aktīva',
          ended: 'Pabeigta',
        },
        empty: 'Nav piešķirta neviena prakses vieta',
        emptyDescription:
          'Kad izglītības iestāde piešķirs jums prakses vietu, tā būs redzama šeit.',
        loadError: 'Neizdevās ielādēt prakses vietas',
        loadErrorHelp: 'Pārbaudiet savienojumu un mēģiniet vēlreiz.',
        evaluationTitle: 'Prakses vietas vērtējums',
        evaluationLoadError: 'Neizdevās ielādēt prakses vietas vērtējumu',
        evaluationLoadErrorHelp: 'Pārbaudiet savienojumu un mēģiniet vēlreiz.',
        evaluationEmpty: 'Šis vērtējums nesatur atbildes.',
        evaluationLoading: 'Ielādē prakses vietas vērtējumu',
        viewEvaluation: 'Apskatīt vērtējumu',
        evaluationUnavailable: 'Prakses vieta šo vērtējumu vēl nav aizpildījusi',
        evaluationUnavailableHelp: 'Šeit tas parādīsies, tiklīdz prakses vieta to iesniegs.',
        fields: {
          name: 'Nosaukums',
          address: 'Adrese',
          period: 'Periods',
          supervisor: 'Prakses vadītājs',
          email: 'E-pasts',
          phone: 'Tālrunis',
        },
      },
      internships: {
        title: 'Prakses',
        count_one: '{{count}} prakse',
        count_other: '{{count}} prakses',
        description:
          'Prakses statusu nosaka datumi — beigu datums pagātnē nozīmē, ka prakse ir beigusies, bet sākums nākotnē — ka tā vēl tikai gaidāma.',
        search: 'Meklēt praksi pēc nosaukuma, grupas vai programmas…',
        empty: 'Šajā skatā nav prakšu',
        emptyDescription: 'Pamēģiniet citu statusa cilni vai meklēšanas vaicājumu.',
        statusTabs: 'Prakšu statusi',
        columns: {
          name: 'Prakse',
          status: 'Statuss',
          period: 'Periods',
          program: 'Programma',
          questionGroup: 'Anketa',
          agreement: 'Līgums',
          groups: 'Grupas',
          interns: 'Praktikanti',
        },
        programHours: '{{hours}} h',
        statuses: {
          ongoing: 'Notiek',
          upcoming: 'Gaidāmās',
          finished: 'Beigušās',
          all: 'Visas',
        },
        actions: {
          create: 'Izveidot praksi',
        },
        messages: {
          created_one: 'Prakse izveidota; pievienots {{count}} praktikants',
          created_other: 'Prakse izveidota; pievienoti {{count}} praktikanti',
        },
        wizard: {
          progress: 'Prakses izveides soļi',
          steps: {
            basic: 'Pamatinfo',
            groups: 'Studentu grupa',
            templates: 'Programma un anketa',
            summary: 'Kopsavilkums',
          },
          stepOf: 'Solis {{current}} no {{total}}',
          next: 'Tālāk',
          fields: {
            name: 'Prakses nosaukums',
            class: 'Specialitāte',
            start: 'Sākas',
            end: 'Beidzas',
            supervisor: 'Prakses vadītājs pēc noklusējuma',
            dayInputLimit: 'Cik dienas ieraksts paliek atvērts',
            weekHLimit: 'Stundu limits nedēļā',
            isDVB: 'DVB prakse (darba vidē balstīta)',
            categories: 'Vakanču kategorijas',
          },
          placeholders: {
            name: 'piem. Pavāra prakse 2026/27 (3. kurss)',
            class: 'Izvēlieties specialitāti',
            supervisor: '— nav —',
          },
          help: {
            dayInputLimit: '0 = nav ierobežojuma.',
            weekHLimit: '0 = nav ierobežojuma; citādi mazāks par 140.',
            categories: 'Vismaz viena.',
          },
          dateHelp:
            'Prakses statusu nosaka datumi. Pirms sākuma datuma praktikanti ierakstus veidot nevar.',
          validation: {
            name: 'Ievadiet prakses nosaukumu',
            class: 'Izvēlieties specialitāti',
            start: 'Norādiet sākuma datumu',
            end: 'Norādiet beigu datumu',
            endAfterStart: 'Beigu datumam jābūt pēc sākuma datuma',
            nonNegative: 'Vērtībai jābūt 0 vai lielākai',
            weekHours: 'Nedēļas stundu limitam jābūt no 0 līdz 139',
            category: 'Izvēlieties vismaz vienu kategoriju',
            group: 'Izvēlieties vismaz vienu studentu grupu',
            program: 'Izvēlieties prakses programmu',
            questionnaire: 'Izvēlieties noslēguma anketu',
          },
          errors: {
            validation: 'Neizdevās pārbaudīt šo soli',
            summary: 'Neizdevās ielādēt kopsavilkumu',
            summaryInvalid: 'Kopsavilkumā ir kļūdas. Pārbaudiet izvēlētos laukus.',
            create: 'Neizdevās izveidot praksi',
          },
          groups: {
            title: 'Izvēlieties studentu grupas',
            description: 'Varat pievienot vairākas aktīvās grupas no izvēlētās specialitātes.',
            year: 'Gads',
            allYears: 'Visi gadi',
            students_one: '{{count}} students',
            students_other: '{{count}} studenti',
            studentsDescription_one: 'Aktīvs {{count}} students šajā grupā',
            studentsDescription_other: 'Aktīvi {{count}} studenti šajā grupā',
            empty: 'Šai specialitātei grupas nav atrastas',
            emptyDescription: 'Izvēlieties citu gadu vai pārbaudiet studentu reģistru.',
            help: 'Studenti nav jāveido no jauna. Vienu un to pašu grupu var pievienot neierobežotam skaitam prakšu.',
          },
          templates: {
            programTitle: 'Prakses programma',
            programDescription: '{{count}} aktīvi plāna punkti',
            programEmpty: 'Nav pieejamu aktīvu programmu ar plāna punktiem.',
            questionnaireTitle: 'Noslēguma anketa',
            questionnaireDescription: '{{count}} aktīvi jautājumi',
            questionnaireEmpty: 'Nav pieejamu aktīvu noslēguma anketu ar jautājumiem.',
            items_one: '{{count}} punkts',
            items_other: '{{count}} plāna punkti',
            questions_one: '{{count}} jautājums',
            questions_other: '{{count}} jautājumi',
            hours: '{{count}} h',
          },
          summary: {
            name: 'Prakse',
            period: 'Periods',
            class: 'Specialitāte',
            supervisor: 'Prakses vadītājs',
            groups: 'Studentu grupas',
            program: 'Programma',
            questionnaire: 'Anketa',
            studentsToPlace: 'Tiks izveidoti praktikanti',
          },
        },
      },
      programs: {
        title: 'Programmas',
        description:
          'Veidojiet atkārtoti izmantojamas prakses programmu sagataves un sakārtojiet tajās apgūstamos plāna punktus.',
        search: 'Meklēt pēc programmas vai profesijas…',
        empty: 'Programmas nav atrastas',
        backToList: 'Atpakaļ uz programmām',
        copySuffix: 'kopija',
        cloneExplanation: 'Tiks nokopēti tikai aktīvie programmas plāna punkti.',
        hoursValue: '{{count}} h',
        internshipsValue: '{{count}} praksēs',
        snapshotExplanation:
          'Šo sagatavi izmanto {{count}} prakses. Izmaiņas attiecas uz sagatavi; jau sāktajām praksēm saglabājas to programmas kopija.',
        fields: {
          name: 'Nosaukums',
          profession: 'Profesija',
          professionDescription: 'Neobligāts brīva teksta lauks',
          type: 'Veids',
          hours: 'Stundas',
          status: 'Statuss',
        },
        columns: {
          name: 'Programma',
          profession: 'Profesija',
          type: 'Veids',
          hours: 'Stundas',
          planPoints: 'Plāna punkti',
          internships: 'Izmantota praksēs',
          status: 'Statuss',
        },
        types: {
          Detailed: 'Ar noteiktām stundām',
          Simple: 'Bez noteiktām stundām',
        },
        statuses: {
          all: 'Visi',
          active: 'Aktīva',
          inactive: 'Izslēgta',
        },
        filters: {
          button: 'Filtri',
          title: 'Filtrēt programmas',
          clear: 'Notīrīt',
          apply: 'Filtrēt',
          active: 'Aktīvie filtri',
          remove: 'Noņemt filtru “{{filter}}”',
        },
        actions: {
          create: 'Izveidot programmu',
          createAndAddPoints: 'Izveidot un pievienot plāna punktus',
          menu: 'Programmas darbības',
          openPlanPoints: 'Plāna punkti',
          edit: 'Rediģēt programmu',
          clone: 'Klonēt programmu',
          toggle: 'Mainīt programmas statusu',
          save: 'Saglabāt',
          disable: 'Izslēgt',
          enable: 'Ieslēgt',
        },
        validation: {
          name: 'Ievadiet programmas nosaukumu',
          simpleHours: 'Ievadiet stundu skaitu (vismaz 1 h)',
        },
        confirmDisable: 'Vai izslēgt programmu “{{program}}”?',
        confirmEnable: 'Vai ieslēgt programmu “{{program}}”?',
        messages: {
          created: 'Programma izveidota',
          updated: 'Programma saglabāta',
          cloned: 'Programma noklonēta',
          enabled: 'Programma ieslēgta',
          disabled: 'Programma izslēgta',
        },
      },
      planPoints: {
        search: 'Meklēt plāna punktu…',
        createIntro:
          'Punkts nosaka, ko praktikants dara un kurš to vērtē. Praktikants pie katra ieraksta izvēlas vienu punktu.',
        empty: 'Programmai nav plāna punktu',
        emptyFiltered: 'Nav atrasts neviens atbilstošs plāna punkts',
        emptyDescription:
          'Pievienojiet vismaz vienu punktu un norādiet tā stundas, vērtētāju un vērtēšanas veidu.',
        fields: {
          title: 'Punkta nosaukums',
          hours: 'Stundas',
          simpleHoursDescription: 'Šīs programmas stundas norāda programmas līmenī.',
          grader: 'Kurš vērtē',
          type: 'Vērtējuma veids',
          status: 'Statuss',
        },
        columns: {
          title: 'Plāna punkts',
          records: 'Ierakstu skaits',
          hours: 'Stundas',
          grader: 'Vērtētājs',
          type: 'Vērtējuma veids',
          status: 'Statuss',
        },
        graders: {
          Org: 'Prakses vieta',
          Edu: 'Izglītības iestāde',
          None: 'Nevērtē',
        },
        types: {
          None: 'Bez vērtējuma',
          Info: 'Informācija (tikai lasāms)',
          v10: '1–10',
          v5: '1–5',
          INI: 'I/NI',
          INI10: '1–10 un I/NI',
          Check: 'Atzīme',
        },
        statuses: {
          all: 'Visi',
          active: 'Aktīvs',
          inactive: 'Izslēgts',
        },
        filters: {
          button: 'Filtri',
          title: 'Filtrēt plāna punktus',
          clear: 'Notīrīt',
          apply: 'Filtrēt',
          active: 'Aktīvie filtri',
          remove: 'Noņemt filtru “{{filter}}”',
        },
        actions: {
          create: 'Pievienot plāna punktu',
          add: 'Pievienot punktu',
          edit: 'Rediģēt plāna punktu',
          save: 'Saglabāt',
          toggle: 'Mainīt plāna punkta statusu',
          disable: 'Izslēgt',
          enable: 'Ieslēgt',
          delete: 'Dzēst',
          menu: 'Plāna punkta darbības',
          reorder: 'Mainīt secību',
          dragToReorder: 'Pārvelciet, lai mainītu secību',
          clearFiltersToReorder: 'Notīriet meklēšanu un filtrus, lai mainītu secību',
          reorderPoint: 'Mainīt plāna punkta “{{point}}” secību',
          moveUp: 'Pārvietot augstāk',
          moveDown: 'Pārvietot zemāk',
        },
        validation: {
          title: 'Ievadiet plāna punkta nosaukumu',
          hours: 'Ievadiet veselu stundu skaitu, kas nav mazāks par 0',
        },
        confirmDelete: 'Vai neatgriezeniski dzēst plāna punktu “{{point}}”?',
        confirmDisable: 'Vai izslēgt plāna punktu “{{point}}”?',
        confirmEnable: 'Vai ieslēgt plāna punktu “{{point}}”?',
        messages: {
          created: 'Plāna punkts izveidots',
          updated: 'Plāna punkts saglabāts',
          deleted: 'Plāna punkts dzēsts',
          enabled: 'Plāna punkts ieslēgts',
          disabled: 'Plāna punkts izslēgts',
        },
      },
      surveys: {
        title: 'Noslēguma anketas',
        description:
          'Anketu prakses beigās aizpilda prakses vieta par katru praktikantu — tas ir raksturojums, kas nonāk arī dienasgrāmatas PDF. Pievienojot anketu praksei, tiek izveidota tās kopija.',
        search: 'Meklēt anketu…',
        questionsSearch: 'Meklēt jautājumu…',
        empty: 'Anketas nav atrastas',
        questionsEmpty: 'Šai anketai nav jautājumu',
        questionsEmptyFiltered: 'Nav atrasts neviens atbilstošs jautājums',
        questionsEmptyDescription: 'Pievienojiet vismaz vienu jautājumu šai anketai.',
        backToList: 'Atpakaļ uz anketām',
        noDescription: 'Bez apraksta',
        internshipsValue: '{{count}} praksēs',
        snapshotExplanation:
          'Šo sagatavi izmanto {{count}} prakses. Izmaiņas attiecas uz sagatavi; jau sāktajām praksēm saglabājas to anketas kopija.',
        fields: {
          name: 'Nosaukums',
          description: 'Apraksts',
          questions: 'Jautājumi',
          status: 'Statuss',
        },
        columns: {
          name: 'Anketa',
          description: 'Apraksts',
          questions: 'Jautājumi',
          internships: 'Izmantota praksēs',
          status: 'Statuss',
        },
        statuses: {
          all: 'Visi',
          active: 'Aktīva',
          inactive: 'Izslēgta',
        },
        questionStatuses: {
          active: 'Aktīvs',
          inactive: 'Izslēgts',
        },
        questionsColumns: {
          position: 'Nr.',
          text: 'Jautājums',
          type: 'Atbildes veids',
          weight: 'Svars',
          status: 'Statuss',
          answers: 'Atbildes',
        },
        questionTypes: {
          Text: 'Tekstuāla atbilde',
          Info: 'Info',
          v10: '1 – 10',
          v5: '1 – 5',
          INI: 'I/NI',
          INI10: 'I/NI 10',
          Check: 'Atzīme',
          None: '—',
        },
        filters: {
          button: 'Filtri',
          title: 'Filtrēt anketas',
          clear: 'Notīrīt',
          apply: 'Filtrēt',
          active: 'Aktīvie filtri',
          remove: 'Noņemt filtru “{{filter}}”',
        },
        actions: {
          create: 'Izveidot anketu',
          createAndAddQuestions: 'Izveidot un pievienot jautājumus',
          edit: 'Rediģēt anketu',
          clone: 'Klonēt anketu',
          toggle: 'Mainīt anketas statusu',
          delete: 'Dzēst anketu',
          menu: 'Anketas darbības',
          openDetails: 'Jautājumi',
          save: 'Saglabāt',
          disable: 'Izslēgt',
          enable: 'Ieslēgt',
        },
        validation: {
          name: 'Ievadiet anketas nosaukumu',
        },
        cloneSuffix: 'kopija',
        cloneExplanation: 'Tiks nokopēti tikai aktīvie anketas jautājumi.',
        confirmDisable: 'Vai izslēgt anketu “{{name}}”?',
        confirmEnable: 'Vai ieslēgt anketu “{{name}}”?',
        confirmDelete: 'Vai neatgriezeniski dzēst anketu “{{name}}”?',
        confirmDeleteWithInternships:
          'Anketa tiek izmantota {{count}} praksēs. Dzēšana nav atļauta, kamēr tā ir piesaistīta praksēm.',
        messages: {
          created: 'Anketa izveidota',
          updated: 'Anketa saglabāta',
          cloned: 'Anketa noklonēta',
          enabled: 'Anketa ieslēgta',
          disabled: 'Anketa izslēgta',
          deleted: 'Anketa dzēsta',
          questionCreated: 'Jautājums pievienots',
          questionUpdated: 'Jautājums saglabāts',
          questionDeleted: 'Jautājums dzēsts',
          answersDeleted: 'Atbildes dzēstas',
          moved: 'Jautājums pārvietots',
        },
        questionFields: {
          text: 'Jautājuma teksts',
          type: 'Atbildes veids',
          weight: 'Svars',
        },
        questionValidation: {
          text: 'Ievadiet jautājuma tekstu',
        },
        questionActions: {
          create: 'Pievienot jautājumu',
          edit: 'Rediģēt jautājumu',
          toggle: 'Mainīt jautājuma statusu',
          delete: 'Dzēst jautājumu',
          menu: 'Jautājuma darbības',
          reorder: 'Mainīt secību',
          dragToReorder: 'Pārvelciet, lai mainītu secību',
          clearFiltersToReorder: 'Notīriet meklēšanu un filtrus, lai mainītu secību',
          reorderQuestion: 'Mainīt jautājuma “{{question}}” secību',
          moveUp: 'Pārvietot augstāk',
          moveDown: 'Pārvietot zemāk',
          disable: 'Izslēgt',
          enable: 'Ieslēgt',
        },
        confirmDeleteQuestion: 'Vai neatgriezeniski dzēst jautājumu “{{text}}”?',
        confirmDeleteQuestionWithAnswers:
          'Jautājums izmantots {{count}} atbildēs. Dzēst atbildes un tad jautājumu?',
        errors: {
          missingId: '{{entity}} atbilde nesatur identifikatoru',
          notFound: 'Anketa nav atrasta',
        },
      },
      platformUsers: {
        title: 'Lietotāji',
        search: 'Meklēt lietotāju…',
        searchButton: 'Meklēt',
        clear: 'Notīrīt',
        filters: 'Filtri',
        filterTitle: 'Filtrēt lietotājus',
        status: 'Statuss',
        lastLoginFrom: 'Pēdējā pieslēgšanās no',
        lastLoginTill: 'Pēdējā pieslēgšanās līdz',
        showOnly: 'Rādīt tikai',
        hasInternships: 'Ir prakses',
        hasOrgs: 'Ir organizācijas',
        hasEduOrgs: 'Ir izglītības iestādes',
        applyFilters: 'Filtrēt',
        activeFilters: 'Aktīvie filtri',
        removeFilter: 'Noņemt filtru “{{filter}}”',
        pageSize: 'Lietotāju skaits lapā',
        range: 'Rāda {{from}}–{{to}} no {{total}}',
        empty: 'Lietotāji nav atrasti',
        cancel: 'Atcelt',
        confirm: 'Apstiprināt',
        close: 'Aizvērt',
        confirmAction: 'Vai veikt šo darbību lietotājam {{user}}?',
        generatedPassword: 'Jaunā parole',
        generatedPasswordWarning:
          'Parole tiek parādīta tikai vienu reizi. Nododiet to lietotājam drošā veidā.',
        statuses: {
          all: 'Visi (bez deaktivizētiem)',
          active: 'Aktīvs',
          lockedOut: 'Bloķēts',
          disabled: 'Deaktivizēts',
        },
        columns: {
          firstName: 'Vārds',
          lastName: 'Uzvārds',
          status: 'Statuss',
          email: 'E-pasts',
          roles: 'Lomas',
          lastLogin: 'Pēdējā pieslēgšanās',
          actions: 'Darbības',
        },
        actions: {
          unlock: 'Atbloķēt',
          forceChangePWD: 'Piespiest mainīt paroli',
          resetPWD: 'Atiestatīt paroli un nosūtīt e-pastu',
          resetPWDAndShow: 'Atiestatīt un parādīt paroli',
          changeLang: 'Mainīt valodu',
          loginAs: 'Sākt atbalsta sesiju…',
          disable: 'Deaktivizēt',
        },
        actionSuccess: {
          unlock: 'Lietotājs atbloķēts',
          forceChangePWD: 'Lietotājam būs jāmaina parole',
          resetPWD: 'Parole atiestatīta un nosūtīta e-pastā',
          resetPWDAndShow: 'Parole atiestatīta',
        },
        details: {
          open: 'Papildu informācija',
          security: 'Drošība',
          activity: 'Aktivitāte',
          provider: 'Konta veids',
          mustChangePassword: 'Jāmaina parole',
          mustChangeEmail: 'Jāmaina e-pasts',
          failedAttempts: 'Neveiksmīgie mēģinājumi',
          lockedUntil: 'Bloķēts līdz',
          lastOrganization: 'Pēdējā aktīvā organizācija',
          language: 'Valoda',
          organizations: 'Organizācijas',
          educationalInstitutions: 'Izglītības iestādes',
          student: 'Students',
          internships: 'Prakses',
          basic: 'Basic',
          addBasic: 'Pievienot Basic kontu',
          addBasicConfirm:
            'Lietotājam tiks pievienots individuālais konts (Basic) un nosūtīts paziņojums e-pastā.',
          addBasicFailed: 'Neizdevās pievienot Basic kontu',
          basicAdded: 'Basic konts pievienots',
        },
      },
      organizationUsers: {
        settings: 'Iestatījumi',
        count_zero: '{{count}} lietotāju',
        count_one: '{{count}} lietotājs',
        count_other: '{{count}} lietotāji',
        institutionDescription:
          'Lomas ir kumulatīvas: pārvaldnieks var visu, ko prakses vadītājs, un administrators — visu, ko pārvaldnieks. Izvēlne katram lietotājam veidojas kā ieslēgto lomu apvienojums.',
        workplaceDescription:
          'Katram lietotājam var būt viena vai vairākas lomas. Lomas nosaka, ko viņš redz un ko drīkst darīt. Izvēlne veidojas kā visu ieslēgto lomu apvienojums.',
        platformTitle: 'Edy365 lietotāji',
        platformUserRole: 'Lietotājs',
        institutionTitle: 'Iestādes lietotāji',
        workplaceTitle: 'Prakses vietas lietotāji',
        institutionRoleExplanation:
          '<strong>Prakses vadītājs</strong> redz tikai sev piešķirtos praktikantus. <strong>Pārvaldnieks</strong> papildus veido prakses, programmas, anketas, grupas un studentus. <strong>Administrators</strong> papildus pārvalda kontu un lietotājus. <strong>Atbalsts</strong> ir kontaktpersona, ko praktikanti un prakses vietas redz palīdzības logā.',
        workplaceRoleExplanation:
          '<strong>Prakses vadītājs</strong> strādā ar sev piešķirtajiem praktikantiem. <strong>Administrators</strong> pārvalda prakses vietas kontu, lietotājus un visu prakses procesu.',
        search: 'Meklēt lietotāju…',
        empty: 'Lietotāji nav atrasti',
        filters: 'Filtri',
        filterTitle: 'Filtrēt lietotājus',
        filterRoles: 'Lomas',
        internFilter: 'Piešķirtie praktikanti',
        clear: 'Notīrīt',
        applyFilters: 'Filtrēt',
        activeFilters: 'Aktīvie filtri',
        removeFilter: 'Noņemt filtru “{{filter}}”',
        invite: 'Uzaicināt',
        inviteDescription:
          'Lietotājs saņems uzaicinājumu pievienoties šai organizācijai. Uzaicinājums ir derīgs 24 stundas.',
        create: 'Izveidot lietotāju',
        initialRole: 'Sākotnējā loma',
        invited: 'Uzaicinājums nosūtīts uz {{email}}',
        created: 'Lietotājs izveidots',
        createInvited:
          'Šim e-pastam jau ir konts — uzaicinājums pievienoties nosūtīts uz {{email}}',
        createNoSeat:
          'Lietotājs izveidots, bet licence nebija pieejama, tāpēc loma netika piešķirta.',
        roleUpdated: 'Loma atjaunināta',
        roleToggle: 'Loma “{{role}}” lietotājam {{user}}',
        roleLocked: 'Šo lomu pašlaik nevar mainīt',
        confirmResetPassword:
          'Vai atiestatīt paroli lietotājam {{user}}? Jaunā parole tiks nosūtīta e-pastā, un aktīvās sesijas tiks pārtrauktas.',
        confirmRemove:
          'Vai noņemt lietotāju {{user}} no šīs organizācijas? Lietotāja konts netiks dzēsts.',
        interns: {
          all: 'Visi lietotāji',
          hasInterns: 'Ir piešķirti praktikanti',
          noInterns: 'Nav piešķirtu praktikantu',
        },
        roles: {
          User: 'Prakses vadītājs',
          Manager: 'Pārvaldnieks',
          Admin: 'Administrators',
          Support: 'Atbalsts',
          None: 'Bez lomas',
        },
        columns: {
          user: 'Lietotājs',
          firstName: 'Vārds',
          lastName: 'Uzvārds',
          email: 'E-pasts',
          phone: 'Tālrunis',
          internCount: 'Piešķirtie praktikanti',
          unratedCount: 'Nenovērtētie ieraksti',
          lastLogin: 'Pēdējā pieslēgšanās',
          actions: 'Darbības',
          role: 'Loma',
          state: 'Statuss',
          invitedBy: 'Uzaicināja',
          createdUtc: 'Nosūtīts',
          validTill: 'Derīgs līdz',
        },
        actions: {
          resetPassword: 'Atiestatīt paroli',
          remove: 'Noņemt no organizācijas',
        },
        actionSuccess: {
          resetPassword: 'Parole atiestatīta un nosūtīta e-pastā',
          remove: 'Lietotājs noņemts no organizācijas',
        },
        tabs: {
          label: 'Lietotāju sadaļas',
          users: 'Lietotāji',
          invites: 'Uzaicinājumi',
        },
        invitesEmpty: 'Uzaicinājumu nav',
        inviteStates: {
          Pending: 'Gaida atbildi',
          Expired: 'Beidzies',
        },
        inviteActions: {
          cancelInvite: 'Atsaukt uzaicinājumu',
          deleteInvite: 'Dzēst',
        },
        inviteActionSuccess: {
          cancelInvite: 'Uzaicinājums atsaukts',
          deleteInvite: 'Uzaicinājums dzēsts',
        },
        confirmCancelInvite:
          'Vai atsaukt uzaicinājumu, kas nosūtīts uz {{email}}? Saite e-pastā vairs nedarbosies.',
        confirmDeleteInvite: 'Vai dzēst beigušos uzaicinājumu uz {{email}} no saraksta?',
        actionFailed: 'Darbību neizdevās izpildīt',
        validation: {
          firstName: 'Ievadiet vārdu',
          lastName: 'Ievadiet uzvārdu',
          email: 'Ievadiet derīgu e-pasta adresi',
        },
      },
      internalEmails: {
        title: 'E-pastu pārvaldība',
        search: 'Meklēt e-pastu…',
        searchButton: 'Meklēt',
        clear: 'Notīrīt',
        deleteAll: 'Dzēst visus e-pastus',
        confirmDeleteAll: 'Vai tiešām neatgriezeniski dzēst visus pārtvertos e-pastus?',
        confirmDelete: 'Vai dzēst e-pastu “{{subject}}”?',
        confirmSend: 'Vai atkārtoti nosūtīt e-pastu uz {{email}}?',
        targetEmail: 'Saņēmēja e-pasts',
        invalidEmail: 'Ievadiet derīgu e-pasta adresi',
        previewTitle: 'E-pasta priekšskatījums',
        sent: 'E-pasts nosūtīts',
        deleted: 'E-pasts dzēsts',
        deletedAll: 'Visi e-pasti dzēsti',
        empty: 'E-pasti nav atrasti',
        pageSize: 'E-pastu skaits lapā',
        range: 'Rāda {{from}}–{{to}} no {{total}}',
        columns: {
          email: 'E-pasts',
          subject: 'Tēma',
          date: 'Datums',
          actions: 'Darbības',
        },
        actions: {
          view: 'Apskatīt',
          send: 'Sūtīt oriģinālam',
          sendTo: 'Sūtīt uz…',
          delete: 'Dzēst',
        },
      },
      notFound: {
        title: 'Lapa nav atrasta',
        description: 'Pieprasītā lapa neeksistē vai ir pārvietota.',
        backHome: 'Uz sākumlapu',
      },
      technicalSupport: {
        menuItem: 'Tehniskais atbalsts',
        title: 'Tehniskais atbalsts',
        intro: 'Ja kaut kas nestrādā vai nav skaidrs — rakstiet mums.',
        emailLabel: 'E-pasts',
        emailHours: 'Darbdienās 9:00–17:00',
        phoneLabel: 'Tālrunis',
        billingLabel: 'Rēķini un licences',
        includeTitle: 'Kas jāpieraksta vēstulē',
        whatYouDidLabel: 'Ko darījāt',
        whatYouDidValue: 'Kurā sadaļā bijāt un uz ko nospiedāt',
        whatHappenedLabel: 'Kas notika',
        whatHappenedValue: 'Ko redzējāt ekrānā, nevis ko gaidījāt',
        screenshotLabel: 'Ekrānšāviņš',
        screenshotValue: 'Ļoti palīdz — pievienojiet, ja varat',
        phoneHintLabel: 'Tālrunis',
        phoneHintValue:
          'Norādiet savu numuru — ja kaut kas nebūs skaidrs, mēs piezvanīsim, un jautājums atrisināsies ātrāk',
        close: 'Aizvērt',
        writeToSupport: 'Rakstīt atbalstam',
      },
    },
  },
  en: {
    translation: {
      registration: registrationTranslations.en,
      acceptInvite: acceptInviteTranslations.en,
      sessionGate: sessionGateTranslations.en,
      educationalRegistration: educationalRegistrationTranslations.en,
      myProfile: myProfileTranslations.en,
      myCv: myCvTranslations.en,
      terms: termsTranslations.en,
      institutionProfile: institutionProfileTranslations.en,
      organizationProfile: organizationProfileTranslations.en,
      organizationRegistration: organizationRegistrationTranslations.en,
      payments: paymentTranslations.en,
      edyStatistics: edyStatisticsTranslations.en,
      edySupportCases: edySupportCasesTranslations.en,
      edyOrganizations: edyOrganizationsTranslations.en,
      edyEduOrganizations: edyEduOrganizationsTranslations.en,
      savedDevices: savedDeviceTranslations.en,
      vacancies: vacancyTranslations.en,
      myOrgInterns: myOrgInternTranslations.en,
      myEduInterns: myEduInternTranslations.en,
      orgInterns: orgInternTranslations.en,
      orgDiary: orgDiaryTranslations.en,
      eduDiary: eduDiaryTranslations.en,
      eduInternDetails: eduInternDetailsTranslations.en,
      eduInterns: eduInternTranslations.en,
      internshipDetails: internshipDetailsTranslations.en,
      internDetails: internDetailsTranslations.en,
      futureInternships: futureInternshipTranslations.en,
      applications: applicationTranslations.en,
      absence: absenceTranslations.en,
      diary: diaryTranslations.en,
      diaryEntry: diaryEntryTranslations.en,
      internshipHub: internshipHubTranslations.en,
      agreements: agreementTranslations.en,
      orgAgreements: orgAgreementTranslations.en,
      internAgreements: internAgreementTranslations.en,
      internVacancies: internVacancyTranslations.en,
      myApplications: myApplicationTranslations.en,
      agreementTemplates: agreementTemplateTranslations.en,
      internshipActions: internshipActionTranslations.en,
      internshipFilters: internshipFilterTranslations.en,
      common: {
        yes: 'Yes',
        no: 'No',
        close: 'Close',
        cancel: 'Cancel',
        back: 'Back',
        unexpectedError: 'Could not load the data',
        retry: 'Try again',
        actionsLoading: 'Loading actions',
        actionsLoadFailed: 'Could not load the actions',
        noActions: 'No actions available',
      },
      navigation: {
        sidebar: 'Main navigation',
        mobile: 'Mobile navigation',
        more: 'More',
        moreMenu: 'More sections',
        sections: 'Sections',
        collapseSidebar: 'Collapse navigation',
        expandSidebar: 'Expand navigation',
        mobilePages: {
          emailManagement: 'Emails',
        },
        groups: {
          internships: 'Internships',
          internshipDocuments: 'Internship documents',
          students: 'Student registry',
          templates: 'Templates',
          workplaces: 'Workplaces',
          recruitment: 'Intern recruitment',
          administration: 'Administration',
        },
        pages: {
          users: 'Users',
          educationalInstitutions: 'Educational institutions',
          workplaces: 'Internship places',
          statistics: 'Statistics',
          finances: 'Finances',
          support: 'Support',
          emailManagement: 'Email management',
          students: 'Students',
          internships: 'Internships',
          interns: 'Interns',
          programs: 'Programs',
          surveys: 'Final surveys',
          agreements: 'Agreements',
          agreementTemplates: 'Agreement templates',
          internshipHub: 'Internship hub',
          diary: 'Diary',
          internshipProgram: 'Internship programme',
          absence: 'Absence',
          myWorkplace: 'My workplace',
          vacancySearch: 'Vacancies',
          myApplications: 'My applications',
          myProfile: 'My profile',
          savedDevices: 'Saved devices',
          myCv: 'My CV',
          institutionProfile: 'Institution profile',
          institutionUsers: 'Institution users',
          workplaceProfile: 'Organization profile',
          createOrganization: 'Create organization',
          workplaceUsers: 'Workplace users',
          platformMembers: 'Edy365 users',
          payments: 'Payments',
        },
      },
      pagination: {
        first: 'First page',
        previous: 'Previous page',
        next: 'Next page',
        last: 'Last page',
      },
      dataTable: {
        search: 'Search',
        clearSearch: 'Clear search',
        columns: 'Columns',
        visibleColumns: 'Visible columns',
        enableAllColumns: 'Enable all',
        resetColumns: 'Reset',
        done: 'Done',
        resizeColumn: 'Resize “{{column}}” column',
        pageSize: 'Rows per page',
        rowsPerPage: '{{count}} / page',
        range: 'Showing {{from}}–{{to}} of {{total}}',
      },
      session: {
        signIn: 'Sign in',
        signInDescription: 'Sign in to continue to edy365.',
        signInErrorTitle: 'Unable to sign in',
        signInError: 'Check your email and password, then try again.',
        loginCode: 'Login code',
        codeSentTo: 'A code was sent to {{email}}.',
        codeValidity: 'The code is valid for 10 minutes.',
        code: 'Code',
        codeRequired: 'Enter your login code',
        rememberDevice: 'Remember this browser for 60 days',
        verifyCode: 'Verify',
        resendCode: 'Resend code',
        codeResent: 'A new code was sent.',
        codeVerificationError: 'Unable to verify the code. Try again or return to sign in.',
        codeResendError: 'Unable to resend the code. Try again or return to sign in.',
        signOut: 'Sign out',
        email: 'Email',
        emailRequired: 'Enter your email address',
        emailInvalid: 'Enter a valid email address',
        password: 'Password',
        passwordRequired: 'Enter your password',
        passwordInvalid: 'Password is too long',
        passwordVisibility: 'Show or hide password',
        restoring: 'Restoring session…',
        language: 'Language',
        forgotPassword: 'Forgot password?',
        forgotPasswordDescription:
          "Enter your account email and we'll send you a secure password reset link.",
        forgotPasswordErrorTitle: 'Unable to send reset link',
        forgotPasswordError: 'Check your connection and try again.',
        resetPassword: 'Reset password',
        resetPasswordDescription: 'Choose a new password for your edy365 account.',
        resetPasswordErrorTitle: 'Unable to reset password',
        sendResetLink: 'Send reset link',
        resetLinkSentTitle: 'Check your email',
        resetLinkSentDescription: 'Instructions were sent to your email address.',
        resetLinkSent: 'If an account with that email exists, you will receive a reset link.',
        backToLogin: 'Back to login',
        newPassword: 'New password',
        newPasswordRequired: 'Enter your new password',
        repeatPassword: 'Repeat password',
        repeatPasswordRequired: 'Repeat your new password',
        passwordRequirements:
          'Use at least 8 characters, including an uppercase letter, a lowercase letter, and a number.',
        invalidTokenTitle: 'Link is not valid',
        invalidToken: 'This reset link is invalid or has expired. Please request a new one.',
        requestNewResetLink: 'Request a new link',
        passwordsDoNotMatch: 'Passwords do not match',
        passwordChangeRequired: 'Change your password to continue.',
        termsAcceptanceTitle: 'Terms of use',
        termsAcceptanceRequired:
          'Accept the terms of use and the personal data processing terms to continue.',
        termsRequired: 'Agree to the terms of use to continue',
        dataPolicyRequired: 'Agree to the personal data processing terms to continue',
        acceptTermsAndContinue: 'Accept and continue',
        termsAcceptanceError: 'Your consent could not be saved. Please try again.',
      },
      supportSession: {
        caseBadge: 'Case {{caseNumber}}',
        startTitle: 'Start support session',
        startWarning:
          'You will work on this user’s behalf. The activity will be recorded under the specified support case.',
        representedUser: 'Represented user',
        caseNumber: 'Case number',
        caseNumberRequired: 'Enter the support case number',
        start: 'Start support session',
        startError: 'Could not start the support session',
        logs: 'Logs',
        noLogs: 'No log entries found.',
        return: 'Return to administrator',
        returnErrorTitle: 'Could not restore the administrator session',
        returnError: 'The Support Session remains active. Try again.',
        summaryTitle: 'Login blockers — {{user}}',
        summaryHint:
          'What the user will meet when signing in themselves. They do not apply in the support session.',
        noBlockers: 'No blockers',
        lockedUntil: 'until {{date}}',
        noTrustedDevices: 'no saved devices',
        exceptTrustedDevices_one: 'except {{count}} saved device',
        exceptTrustedDevices_other: 'except {{count}} saved devices',
        blockers: {
          LockedOut: 'Account locked',
          LoginCodeRequired: 'Login code from the e-mail required',
          MustChangePassword: 'Must change the password',
          MustChangeEmail: 'Must change the e-mail',
          MustAcceptUserTerms: 'Must accept the terms of use',
          MustAcceptUserDataPolicy: 'Must accept the data policy',
          MustAcceptOrgTerms: 'The organization must accept the terms',
          MustAcceptOrgDataPolicy: 'The organization must accept the data policy',
          ConfirmInternDetails: 'Must confirm the intern details',
          ConfirmAgreementDetails: 'Must confirm the agreement details',
        },
        logKinds: {
          userLogs: 'User logs',
          internLogs: 'Internship logs',
          eduLogs: 'Educational institution logs',
          orgLogs: 'Workplace logs',
        },
        logColumns: {
          date: 'Date',
          action: 'Action',
          actor: 'User',
          context: 'Context',
          ip: 'IP address',
        },
      },
      profileMenu: {
        myData: 'My data',
        institutionSettings: 'Institution settings',
        workplaceSettings: 'Workplace settings',
        platformSettings: 'Edy365 settings',
        signOut: 'Sign out',
        roles: {
          institution: {
            user: 'Internship supervisor',
            manager: 'Manager',
            admin: 'Administrator',
            support: 'Support',
          },
          workplace: {
            user: 'Internship supervisor',
            manager: 'Manager',
            admin: 'Administrator',
            support: 'Support',
          },
          platform: {
            user: 'User',
            manager: 'Manager',
            admin: 'Super administrator',
            support: 'Support',
          },
        },
      },
      roleSwitcher: {
        currentSection: 'This account operates as',
        switchSection: 'Switch to',
        contextType: {
          Org: 'Workplace',
          Edu: 'Educational institution',
          Intern: 'Intern',
          Edy365: 'Edy365',
          Student: 'Student',
        },
        explanation:
          'Each context is a separate workspace. Navigation, data, and permissions change together, and only one can be active at a time.',
        errorTitle: 'Could not switch role',
        errorMessage: 'Try again or refresh the page.',
      },
      internshipSwitcher: {
        label: 'My internships',
        status: {
          upcoming: 'upcoming',
          ongoing: 'ongoing',
          ended: 'ended',
        },
        explanation:
          'Internships are added and removed by the educational institution. Ended internships can be viewed but not edited.',
        errorTitle: 'Could not switch internship',
        errorMessage: 'Try again or refresh the page.',
      },
      notifications: {
        title: 'Notifications',
        newCount_one: '{{count}} new',
        newCount_other: '{{count}} new',
        attentionSection: 'Action required',
        noticeSection: 'New notifications',
        markNoticesRead: 'Mark notifications as read',
        empty: 'There are no new notifications',
        loadErrorTitle: 'Could not load notifications',
        loadErrorMessage: 'Check your connection and try again.',
        openErrorTitle: 'Could not open notification',
        openErrorMessage:
          'The role could not be switched or the notification is no longer available.',
        markReadErrorTitle: 'Could not mark notifications',
        markReadErrorMessage: 'Try again.',
        invite: {
          accept: 'Accept',
          decline: 'Decline',
          declineConfirm:
            'Decline the invitation? It will be deleted — to join later, the admin must send a new one.',
          confirmDecline: 'Decline invitation',
          accepted: 'Invitation accepted',
          declined: 'Invitation declined',
          acceptErrorTitle: 'Could not accept the invitation',
          declineErrorTitle: 'Could not decline the invitation',
          errorMessage: 'Try again.',
        },
        events: {
          fallback: 'New notification',
          ProcessInternApplication_one: '{{count}} internship application needs review',
          ProcessInternApplication_other: '{{count}} internship applications need review',
          SignAgreement_one: '{{count}} agreement awaits a signature',
          SignAgreement_other: '{{count}} agreements await signatures',
          AcceptUser_one: '{{count}} user request needs approval',
          AcceptUser_other: '{{count}} user requests need approval',
          AcceptOrgInvite: 'Invitation to join an organization',
          UnratedRecords_one: '{{count}} record needs grading',
          UnratedRecords_other: '{{count}} records need grading',
          InternAcceptedElsewhere: 'The intern was accepted by another workplace',
          InviteAccepted: 'The invitation was accepted',
          InviteAcceptedNamed:
            'User <strong>{{name}}</strong> has joined <strong>{{organization}}</strong>',
          InviteDeclined: 'The invitation was declined',
          OrgInviteWithdrawn: 'The organization invitation was withdrawn',
          OrgInviteExpired: 'The organization invitation expired',
          JoinedOrg: 'You joined an organization',
          JoinedEduAsStudent: 'You joined an educational institution',
          IndividualRoleAdded: 'You were assigned a new individual role',
          OrgRoleAdded: 'You were assigned a new organization role',
          OrgRoleRemoved: 'Your organization role was removed',
          RemovedFromOrg: 'You were removed from the organization',
          RemovedFromOrgNamed: 'You were removed from <strong>{{organization}}</strong>',
          AddedToInternship: 'You were added to an internship',
          MovedToAnotherGroup: 'You were moved to another group',
          InternRevokedByEdu: 'Your educational institution revoked your internship',
          StudentDataEditedByEdu: 'Your educational institution updated your student data',
          PasswordResetByEdu: 'Your educational institution reset your password',
          InternshipDatesChangedByEdu: 'Your educational institution changed your internship dates',
          InternAssignedByEdu: 'An educational institution assigned an intern to you',
          ProcessEduGoLiveRequest_one: '{{count}} go-live request awaits a decision',
          ProcessEduGoLiveRequest_other: '{{count}} go-live requests await a decision',
          EduGoLiveDeclined: 'Activation request declined',
        },
      },
      students: {
        title: 'Students',
        breadcrumb: 'Student registry',
        description:
          'Create a student once. Their group can then be added to future internships without entering their details again.',
        count: '{{count}} students',
        views: {
          list: 'All students',
          structure: 'By structure',
        },
        structure: {
          navigationTitle: 'Specialty → group → students',
          allGroups: 'All groups',
          studentCount: '{{count}} students',
          empty: 'There are no active students in the structure.',
          actions: {
            addClass: 'Add specialty',
            addGroup: 'Add group',
            editClass: 'Edit specialty',
            editGroup: 'Edit group',
            save: 'Save changes',
          },
          class: {
            createTitle: 'Add specialty',
            editTitle: 'Edit specialty',
            title: 'Name',
            notes: 'Notes',
            active: 'Active',
            createIntro:
              'A specialty is the top level of the structure. Groups and students are linked below it.',
            editIntro:
              'The specialty name and notes are used in the student structure and related lists.',
            create: 'Add specialty',
            created: 'Specialty added',
            updated: 'Specialty changes saved',
          },
          group: {
            createTitle: 'Add group',
            editTitle: 'Edit group',
            class: 'Specialty',
            chooseClass: 'Choose a specialty',
            title: 'Group name',
            year: 'Year',
            description: 'Description',
            active: 'Active',
            createIntro:
              'A group belongs to one specialty. Internships can be assigned to the whole group.',
            editIntro:
              'The group specialty cannot be changed here. Edit the group name, year, or description instead.',
            create: 'Add group',
            created: 'Group added',
            updated: 'Group changes saved',
            loadError: 'The group data was not available. Try again.',
          },
          validation: {
            classTitle: 'Enter a specialty name',
            groupClass: 'Choose a specialty',
            groupTitle: 'Enter a group name',
            groupYear: 'Enter a valid year',
          },
        },
        pageSize: 'Students per page',
        add: 'Add student',
        search: 'Search by name, email, or personal code…',
        specialty: 'Specialty',
        group: 'Group',
        status: 'Status',
        admissionYear: 'Admission year',
        all: 'All',
        noPlacement: 'No placement',
        activePlacement: 'In placement',
        archived: 'Archived',
        currentPlacement: 'Current placement',
        personalCode: 'Personal code',
        phone: 'Phone',
        email: 'Email',
        firstName: 'First name',
        lastName: 'Last name',
        invitation: 'Send an email invitation',
        invitationLanguage: 'Invitation language',
        save: 'Add student',
        cancel: 'Cancel',
        created: 'Student added',
        empty: 'No students found',
        actions: 'Student actions',
        edit: 'Edit student',
        moveGroup: 'Move to another group',
        history: 'View internship history',
        archive: 'Archive student',
        columns: {
          name: 'Last name, first name',
          group: 'Group',
          specialty: 'Specialty',
          personalCode: 'Personal code',
          phone: 'Phone',
          status: 'Status',
          currentInternship: 'Current internship',
          actions: 'Student actions',
        },
        filters: {
          button: 'Filters',
          title: 'Student filters',
          class: 'Specialty',
          group: 'Group',
          year: 'Admission year',
          all: 'All',
          clear: 'Clear',
          apply: 'Apply',
          active: 'Active filters',
          remove: 'Remove filter “{{filter}}”',
        },
        statuses: {
          All: 'All',
          InInternship: 'In placement until {{date}}',
          InInternshipShort: 'In placement',
          WithFutureInternships: 'Placement starts {{date}}',
          WithFutureInternshipsShort: 'Upcoming placement',
          WithPastInternships: 'Placement ended {{date}}',
          WithPastInternshipsShort: 'Past placement',
          WithNoInternship: 'No placement',
        },
        rowActions: {
          edit: 'Edit student',
          move: 'Move to another group',
          resetPWD: 'Reset password',
          openHistory: 'View internship history',
        },
        validation: {
          firstName: 'Enter a first name',
          lastName: 'Enter a last name',
          email: 'Enter a valid email address',
          personalCode: 'Enter a personal code',
          group: 'Choose a group',
        },
        create: {
          title: 'Add student',
          chooseGroup: 'Choose a group',
          language: 'Invitation language',
          submit: 'Add student',
          created: 'Student added. Linked to active internships: {{count}}.',
          linked: 'Student linked. Linked to active internships: {{count}}.',
        },
        editStudent: {
          title: 'Edit student',
          save: 'Save changes',
          updated: 'Student details saved',
        },
        moveStudent: {
          title: 'Move to another group',
          review: 'Review move',
          confirm: 'Confirm move',
          back: 'Back',
          currentGroup: 'Current group',
          destinationGroup: 'New group',
          chooseGroup: 'Choose a new group',
          noCurrentGroup: 'No group assigned',
          warning:
            'Moving may change the student’s internships: internships with diary entries may be ended today, while upcoming internships and agreements may be deleted.',
          confirmTitle: 'Move consequences',
          confirmText: 'The student will be moved to “{{group}}”. Continue?',
          updated:
            'Student moved. Ended internships: {{endedInternships}}; deleted internships: {{deletedInternships}}; deleted agreements: {{deletedAgreements}}; joined internships: {{joinedInternships}}.',
          validation: { group: 'Choose a different group' },
        },
        resetPassword: {
          title: 'Reset student password',
          review: 'Review reset',
          confirm: 'Reset password',
          back: 'Back',
          warning:
            'A new password will be generated and emailed to {{email}}. Existing sessions will be signed out, and the student must change the password at the next sign-in.',
          confirmTitle: 'Password reset consequences',
          confirmText:
            'A new password will be generated for {{name}}. The current password will stop working and open sessions will be signed out. Continue?',
          successTitle: 'Password reset',
          successText: 'The new password was emailed to {{email}}.',
          generatedPassword: 'Generated password',
          changeOnNextSignIn: 'The student must change this password at the next sign-in.',
          copy: 'Copy password',
          copied: 'Password copied',
        },
        internshipHistory: {
          title: 'Internship history',
          description:
            'Every internship the student has attended. The data remains available for reading after archival.',
          empty: 'This student has no internship history.',
          error: 'Could not load internship history',
          retry: 'Try again',
          columns: {
            internship: 'Internship',
            period: 'Period',
            place: 'Internship place',
            hours: 'Hours',
            averageGrade: 'Average grade',
          },
          grades: {
            notGraded: '—',
            credited: 'Credited',
            notCredited: 'Not credited',
          },
        },
        import: {
          action: 'Import from file',
          title: 'Import students from file',
          instructions:
            'You can import a whole group at once. If a student is already in the registry, the system recognizes them by personal code and does not create a duplicate.',
          file: 'File',
          chooseFile: 'Choose an XLSX file',
          fileDescription:
            'Use the standard template with first name, last name, personal code, email, and group.',
          class: 'Specialty',
          chooseClass: 'Choose a specialty',
          year: 'Group year',
          chooseYear: 'Choose a year',
          language: 'Language for new accounts',
          languageDescription: 'This language is used for accounts created during the import.',
          preview: 'Preview',
          previewTitle: 'Review students to import',
          previewDescription: '{{className}}, group year {{year}}',
          errorRows: 'Rows with errors cannot be imported. Correct the file and preview it again.',
          selectAll: 'Select all importable rows',
          selectRow: 'Select {{name}}',
          status: 'Status',
          message: 'Explanation',
          back: 'Back',
          submit: 'Import {{count}}',
          completed: 'Import completed',
          completedDescription: '{{count}} selected rows were processed.',
          rejectedRows: 'Rejected rows',
          validation: {
            fileType: 'Choose an XLSX file.',
            fileSize: 'The file must not be larger than 2 MB.',
          },
          counts: {
            new: 'New: {{count}}',
            moved: 'Moved: {{count}}',
            unchanged: 'Unchanged: {{count}}',
            errors: 'Errors: {{count}}',
            created: 'Accounts created',
            linked: 'Accounts linked',
          },
          statuses: {
            New: 'New',
            Moved: 'Moved',
            Unchanged: 'Unchanged',
            Error: 'Error',
            Created: 'Created',
            Linked: 'Linked',
          },
        },
      },
      internshipProgram: {
        title: 'Internship programme',
        summary: '{{count}} Plan Points · {{hours}} h',
        description:
          'The programme was created by the educational institution. Each point has its own hour allocation and evaluator. When adding a Diary Entry, you choose which point it belongs to.',
        search: 'Search Plan Points…',
        empty: 'This internship has no Plan Points',
        emptyFiltered: 'No matching Plan Points found',
        total: 'Total',
        progressLabel: 'Progress: {{value}}',
        columns: {
          title: 'Plan Point',
          planned: 'Planned',
          done: 'Worked',
          left: 'Remaining',
          grader: 'Who evaluates',
          progress: 'Progress',
        },
        graders: {
          Org: 'Workplace',
          Edu: 'Educational institution',
          None: '—',
        },
        filters: {
          button: 'Filters',
          title: 'Filter Plan Points',
          showOnly: 'Show only',
          graded: 'Graded',
          hasRecords: 'Has entries',
          notDone: 'Not completed',
          clear: 'Clear',
          apply: 'Apply filters',
          active: 'Active filters',
          remove: 'Remove filter “{{filter}}”',
        },
      },
      internshipPlace: {
        title: 'My workplace',
        eyebrow: 'Placement overview',
        description:
          'Review your current workplace, contact your supervisor, and revisit past placements.',
        placeCount_one: '{{count}} workplace',
        placeCount_other: '{{count}} workplaces',
        currentCardLabel: 'Current workplace',
        historySection: 'Placement history',
        otherSection: 'Other placements',
        contact: 'Contact person',
        currentStatus: 'Active now',
        status: {
          upcoming: 'Upcoming',
          ongoing: 'Active',
          ended: 'Completed',
        },
        empty: 'No internship place assigned',
        emptyDescription:
          'When your educational institution assigns a workplace, it will appear here.',
        loadError: 'Could not load internship places',
        loadErrorHelp: 'Check your connection and try again.',
        evaluationTitle: 'Internship place evaluation',
        evaluationLoadError: 'Could not load the internship place evaluation',
        evaluationLoadErrorHelp: 'Check your connection and try again.',
        evaluationEmpty: 'This evaluation has no answers.',
        evaluationLoading: 'Loading the internship place evaluation',
        viewEvaluation: 'View evaluation',
        evaluationUnavailable: 'The internship place has not completed this evaluation yet',
        evaluationUnavailableHelp: 'It will appear here once the internship place submits it.',
        fields: {
          name: 'Name',
          address: 'Address',
          period: 'Period',
          supervisor: 'Internship supervisor',
          email: 'Email',
          phone: 'Phone',
        },
      },
      internships: {
        title: 'Internships',
        count_one: '{{count}} internship',
        count_other: '{{count}} internships',
        description:
          'Internship status is determined by dates — a past end date means finished, while a future start date means upcoming.',
        search: 'Search by internship, group or program…',
        empty: 'No internships in this view',
        emptyDescription: 'Try another status tab or search term.',
        statusTabs: 'Internship statuses',
        columns: {
          name: 'Internship',
          status: 'Status',
          period: 'Period',
          program: 'Program',
          questionGroup: 'Questionnaire',
          agreement: 'Agreement',
          groups: 'Groups',
          interns: 'Interns',
        },
        programHours: '{{hours}} h',
        statuses: {
          ongoing: 'Ongoing',
          upcoming: 'Upcoming',
          finished: 'Finished',
          all: 'All',
        },
        actions: {
          create: 'Create internship',
        },
        messages: {
          created_one: 'Internship created; {{count}} intern placed',
          created_other: 'Internship created; {{count}} interns placed',
        },
        wizard: {
          progress: 'Internship creation steps',
          steps: {
            basic: 'Basic info',
            groups: 'Student group',
            templates: 'Program & survey',
            summary: 'Summary',
          },
          stepOf: 'Step {{current}} of {{total}}',
          next: 'Next',
          fields: {
            name: 'Internship name',
            class: 'Specialty',
            start: 'Starts',
            end: 'Ends',
            supervisor: 'Default internship supervisor',
            dayInputLimit: 'Days a diary entry stays open',
            weekHLimit: 'Weekly hour limit',
            isDVB: 'Work-based learning internship',
            categories: 'Vacancy categories',
          },
          placeholders: {
            name: 'e.g. Chef internship 2026/27 (year 3)',
            class: 'Choose a specialty',
            supervisor: '— none —',
          },
          help: {
            dayInputLimit: '0 = no limit.',
            weekHLimit: '0 = no limit; otherwise below 140.',
            categories: 'At least one.',
          },
          dateHelp:
            'Internship status is determined by dates. Interns cannot create entries before the start date.',
          validation: {
            name: 'Enter an internship name',
            class: 'Choose a specialty',
            start: 'Choose a start date',
            end: 'Choose an end date',
            endAfterStart: 'The end date must be after the start date',
            nonNegative: 'Value must be 0 or greater',
            weekHours: 'Weekly hours must be between 0 and 139',
            category: 'Choose at least one category',
            group: 'Choose at least one student group',
            program: 'Choose an internship program',
            questionnaire: 'Choose a closing survey',
          },
          errors: {
            validation: 'Could not validate this step',
            summary: 'Could not load the summary',
            summaryInvalid: 'The summary contains errors. Check the selected fields.',
            create: 'Could not create the internship',
          },
          groups: {
            title: 'Choose student groups',
            description: 'You can add multiple active groups from the selected specialty.',
            year: 'Year',
            allYears: 'All years',
            students_one: '{{count}} student',
            students_other: '{{count}} students',
            studentsDescription_one: '{{count}} active student in this group',
            studentsDescription_other: '{{count}} active students in this group',
            empty: 'No groups found for this specialty',
            emptyDescription: 'Choose another year or check the student registry.',
            help: 'Students do not need to be created again. The same group can be added to any number of internships.',
          },
          templates: {
            programTitle: 'Internship program',
            programDescription: '{{count}} active Plan Points',
            programEmpty: 'No active programs with Plan Points are available.',
            questionnaireTitle: 'Closing survey',
            questionnaireDescription: '{{count}} active questions',
            questionnaireEmpty: 'No active closing surveys with questions are available.',
            items_one: '{{count}} Plan Point',
            items_other: '{{count}} Plan Points',
            questions_one: '{{count}} question',
            questions_other: '{{count}} questions',
            hours: '{{count}} h',
          },
          summary: {
            name: 'Internship',
            period: 'Period',
            class: 'Specialty',
            supervisor: 'Internship supervisor',
            groups: 'Student groups',
            program: 'Program',
            questionnaire: 'Survey',
            studentsToPlace: 'Interns to be created',
          },
        },
      },
      programs: {
        title: 'Programs',
        description:
          'Create reusable internship program templates and organize the Plan Points students should cover.',
        search: 'Search by program or profession…',
        empty: 'No programs found',
        backToList: 'Back to programs',
        copySuffix: 'copy',
        cloneExplanation: 'Only active Plan Points will be copied into the new program.',
        hoursValue: '{{count}} h',
        internshipsValue: '{{count}} internships',
        snapshotExplanation:
          'This template is used by {{count}} internships. Changes affect the template; internships that have already started keep their program snapshot.',
        fields: {
          name: 'Name',
          profession: 'Profession',
          professionDescription: 'Optional free-text field',
          type: 'Type',
          hours: 'Hours',
          status: 'Status',
        },
        columns: {
          name: 'Program',
          profession: 'Profession',
          type: 'Type',
          hours: 'Hours',
          planPoints: 'Plan Points',
          internships: 'Used in internships',
          status: 'Status',
        },
        types: {
          Detailed: 'With fixed hours',
          Simple: 'Without fixed hours',
        },
        statuses: {
          all: 'All',
          active: 'Active',
          inactive: 'Disabled',
        },
        filters: {
          button: 'Filters',
          title: 'Filter programs',
          clear: 'Clear',
          apply: 'Apply filters',
          active: 'Active filters',
          remove: 'Remove filter “{{filter}}”',
        },
        actions: {
          create: 'Create program',
          createAndAddPoints: 'Create and add Plan Points',
          menu: 'Program actions',
          openPlanPoints: 'Plan Points',
          edit: 'Edit program',
          clone: 'Clone program',
          toggle: 'Change program status',
          save: 'Save',
          disable: 'Disable',
          enable: 'Enable',
        },
        validation: {
          name: 'Enter a program name',
          simpleHours: 'Enter the number of hours (at least 1 h)',
        },
        confirmDisable: 'Disable “{{program}}”?',
        confirmEnable: 'Enable “{{program}}”?',
        messages: {
          created: 'Program created',
          updated: 'Program saved',
          cloned: 'Program cloned',
          enabled: 'Program enabled',
          disabled: 'Program disabled',
        },
      },
      planPoints: {
        search: 'Search Plan Points…',
        createIntro:
          'A Plan Point defines what the Intern does and who evaluates it. The Intern selects one Plan Point for each Diary Entry.',
        empty: 'This program has no Plan Points',
        emptyFiltered: 'No matching Plan Points found',
        emptyDescription:
          'Add at least one point and define its hours, evaluator, and grading method.',
        fields: {
          title: 'Plan Point name',
          hours: 'Hours',
          simpleHoursDescription: 'Hours for this program are defined at program level.',
          grader: 'Who evaluates',
          type: 'Grading method',
          status: 'Status',
        },
        columns: {
          title: 'Plan Point',
          records: 'Record count',
          hours: 'Hours',
          grader: 'Evaluator',
          type: 'Grading method',
          status: 'Status',
        },
        graders: {
          Org: 'Workplace',
          Edu: 'Educational institution',
          None: 'No evaluator',
        },
        types: {
          None: 'No grade',
          Info: 'Information (read only)',
          v10: '1–10',
          v5: '1–5',
          INI: 'Pass/fail',
          INI10: '1–10 and pass/fail',
          Check: 'Check',
        },
        statuses: {
          all: 'All',
          active: 'Active',
          inactive: 'Disabled',
        },
        filters: {
          button: 'Filters',
          title: 'Filter Plan Points',
          clear: 'Clear',
          apply: 'Apply filters',
          active: 'Active filters',
          remove: 'Remove filter “{{filter}}”',
        },
        actions: {
          create: 'Add Plan Point',
          add: 'Add point',
          edit: 'Edit Plan Point',
          save: 'Save',
          toggle: 'Change Plan Point status',
          disable: 'Disable',
          enable: 'Enable',
          delete: 'Delete',
          menu: 'Plan Point actions',
          reorder: 'Reorder',
          dragToReorder: 'Drag to reorder',
          clearFiltersToReorder: 'Clear search and filters to reorder',
          reorderPoint: 'Reorder Plan Point “{{point}}”',
          moveUp: 'Move up',
          moveDown: 'Move down',
        },
        validation: {
          title: 'Enter a Plan Point name',
          hours: 'Enter a whole number of hours that is 0 or greater',
        },
        confirmDelete: 'Permanently delete “{{point}}”?',
        confirmDisable: 'Disable “{{point}}”?',
        confirmEnable: 'Enable “{{point}}”?',
        messages: {
          created: 'Plan Point created',
          updated: 'Plan Point saved',
          deleted: 'Plan Point deleted',
          enabled: 'Plan Point enabled',
          disabled: 'Plan Point disabled',
        },
      },
      surveys: {
        title: 'Final surveys',
        description:
          'The final survey is filled out by the workplace for each intern at the end of the internship — it becomes part of the diary PDF. When a survey is attached to an internship, a snapshot is created.',
        search: 'Search surveys…',
        questionsSearch: 'Search questions…',
        empty: 'No surveys found',
        questionsEmpty: 'This survey has no questions',
        questionsEmptyFiltered: 'No matching questions found',
        questionsEmptyDescription: 'Add at least one question to this survey.',
        backToList: 'Back to surveys',
        noDescription: 'No description',
        internshipsValue: '{{count}} internships',
        snapshotExplanation:
          'This template is used by {{count}} internships. Changes affect the template; internships that have already started keep their survey snapshot.',
        fields: {
          name: 'Name',
          description: 'Description',
          questions: 'Questions',
          status: 'Status',
        },
        columns: {
          name: 'Survey',
          description: 'Description',
          questions: 'Questions',
          internships: 'Used in internships',
          status: 'Status',
        },
        statuses: {
          all: 'All',
          active: 'Active',
          inactive: 'Disabled',
        },
        questionStatuses: {
          active: 'Active',
          inactive: 'Disabled',
        },
        questionsColumns: {
          position: 'No.',
          text: 'Question',
          type: 'Answer type',
          weight: 'Weight',
          status: 'Status',
          answers: 'Answers',
        },
        questionTypes: {
          Text: 'Free text',
          Info: 'Info',
          v10: '1 – 10',
          v5: '1 – 5',
          INI: 'Pass/fail',
          INI10: 'Pass/fail 10',
          Check: 'Check',
          None: '—',
        },
        filters: {
          button: 'Filters',
          title: 'Filter surveys',
          clear: 'Clear',
          apply: 'Apply filters',
          active: 'Active filters',
          remove: 'Remove “{{filter}}” filter',
        },
        actions: {
          create: 'Create survey',
          createAndAddQuestions: 'Create and add questions',
          edit: 'Edit survey',
          clone: 'Clone survey',
          toggle: 'Change survey status',
          delete: 'Delete survey',
          menu: 'Survey actions',
          openDetails: 'Questions',
          save: 'Save',
          disable: 'Disable',
          enable: 'Enable',
        },
        validation: {
          name: 'Enter a survey name',
        },
        cloneSuffix: 'copy',
        cloneExplanation: 'Only active questions will be copied into the new survey.',
        confirmDisable: 'Disable “{{name}}”?',
        confirmEnable: 'Enable “{{name}}”?',
        confirmDelete: 'Permanently delete “{{name}}”?',
        confirmDeleteWithInternships:
          'This survey is used by {{count}} internships. Deletion is not allowed while it is attached to internships.',
        messages: {
          created: 'Survey created',
          updated: 'Survey saved',
          cloned: 'Survey cloned',
          enabled: 'Survey enabled',
          disabled: 'Survey disabled',
          deleted: 'Survey deleted',
          questionCreated: 'Question added',
          questionUpdated: 'Question saved',
          questionDeleted: 'Question deleted',
          answersDeleted: 'Answers deleted',
          moved: 'Question moved',
        },
        questionFields: {
          text: 'Question text',
          type: 'Answer type',
          weight: 'Weight',
        },
        questionValidation: {
          text: 'Enter the question text',
        },
        questionActions: {
          create: 'Add question',
          edit: 'Edit question',
          toggle: 'Change question status',
          delete: 'Delete question',
          menu: 'Question actions',
          reorder: 'Reorder',
          dragToReorder: 'Drag to reorder',
          clearFiltersToReorder: 'Clear search and filters to reorder',
          reorderQuestion: 'Reorder question “{{question}}”',
          moveUp: 'Move up',
          moveDown: 'Move down',
          disable: 'Disable',
          enable: 'Enable',
        },
        confirmDeleteQuestion: 'Permanently delete question “{{text}}”?',
        confirmDeleteQuestionWithAnswers:
          'This question is used in {{count}} answers. Delete answers and then the question?',
        errors: {
          missingId: '{{entity}} response did not include an identifier',
          notFound: 'Survey not found',
        },
      },
      platformUsers: {
        title: 'Users',
        search: 'Search users…',
        searchButton: 'Search',
        clear: 'Clear',
        filters: 'Filters',
        filterTitle: 'Filter users',
        status: 'Status',
        lastLoginFrom: 'Last login from',
        lastLoginTill: 'Last login to',
        showOnly: 'Show only',
        hasInternships: 'Has internships',
        hasOrgs: 'Has organizations',
        hasEduOrgs: 'Has educational institutions',
        applyFilters: 'Apply filters',
        activeFilters: 'Active filters',
        removeFilter: 'Remove “{{filter}}” filter',
        pageSize: 'Users per page',
        range: 'Showing {{from}}–{{to}} of {{total}}',
        empty: 'No users found',
        cancel: 'Cancel',
        confirm: 'Confirm',
        close: 'Close',
        confirmAction: 'Perform this action for {{user}}?',
        generatedPassword: 'New password',
        generatedPasswordWarning:
          'This password is shown only once. Give it to the user through a secure channel.',
        statuses: {
          all: 'All except disabled',
          active: 'Active',
          lockedOut: 'Locked',
          disabled: 'Disabled',
        },
        columns: {
          firstName: 'First name',
          lastName: 'Last name',
          status: 'Status',
          email: 'Email',
          roles: 'Roles',
          lastLogin: 'Last login',
          actions: 'Actions',
        },
        actions: {
          unlock: 'Unlock',
          forceChangePWD: 'Require password change',
          resetPWD: 'Reset password and send email',
          resetPWDAndShow: 'Reset and show password',
          changeLang: 'Change language',
          loginAs: 'Start support session…',
          disable: 'Disable',
        },
        actionSuccess: {
          unlock: 'User unlocked',
          forceChangePWD: 'The user must change their password',
          resetPWD: 'Password reset and emailed',
          resetPWDAndShow: 'Password reset',
        },
        details: {
          open: 'Additional information',
          security: 'Security',
          activity: 'Activity',
          provider: 'Account type',
          mustChangePassword: 'Must change password',
          mustChangeEmail: 'Must change email',
          failedAttempts: 'Failed attempts',
          lockedUntil: 'Locked until',
          lastOrganization: 'Last active organization',
          language: 'Language',
          organizations: 'Organizations',
          educationalInstitutions: 'Educational institutions',
          student: 'Student',
          internships: 'Internships',
          basic: 'Basic',
          addBasic: 'Add Basic account',
          addBasicConfirm: 'The user will get an individual account (Basic) and an e-mail notice.',
          addBasicFailed: 'Could not add the Basic account',
          basicAdded: 'Basic account added',
        },
      },
      organizationUsers: {
        settings: 'Settings',
        count_one: '{{count}} user',
        count_other: '{{count}} users',
        institutionDescription:
          'Roles are cumulative: a manager can do everything a supervisor can, and an administrator can do everything a manager can. Each user’s menu combines their enabled roles.',
        workplaceDescription:
          'Users can have one or more roles. Roles determine what they see and what they can do. Their menu combines all enabled roles.',
        platformTitle: 'Edy365 users',
        platformUserRole: 'User',
        institutionTitle: 'Institution users',
        workplaceTitle: 'Workplace users',
        institutionRoleExplanation:
          '<strong>Supervisors</strong> see only their assigned interns. <strong>Managers</strong> also create internships, programs, questionnaires, groups and students. <strong>Administrators</strong> also manage the account and users. <strong>Support</strong> is the contact person shown to interns and workplaces in the help window.',
        workplaceRoleExplanation:
          '<strong>Supervisors</strong> work with the interns assigned to them. <strong>Administrators</strong> manage the workplace account, users, and the complete internship process.',
        search: 'Search users…',
        empty: 'No users found',
        filters: 'Filters',
        filterTitle: 'Filter users',
        filterRoles: 'Roles',
        internFilter: 'Assigned interns',
        clear: 'Clear',
        applyFilters: 'Apply filters',
        activeFilters: 'Active filters',
        removeFilter: 'Remove “{{filter}}” filter',
        invite: 'Invite',
        inviteDescription:
          'The user will receive an invitation to join this organization. The invitation is valid for 24 hours.',
        create: 'Create user',
        initialRole: 'Initial role',
        invited: 'Invitation sent to {{email}}',
        created: 'User created',
        createInvited:
          'This email already has an account — an invitation to join was sent to {{email}}',
        createNoSeat:
          'The user was created, but no seat was available, so the requested role was not granted.',
        roleUpdated: 'Role updated',
        roleToggle: '{{role}} role for {{user}}',
        roleLocked: 'This role cannot be changed right now',
        confirmResetPassword:
          'Reset the password for {{user}}? The new password will be emailed and active sessions will be signed out.',
        confirmRemove:
          'Remove {{user}} from this organization? Their user account will not be deleted.',
        interns: {
          all: 'All users',
          hasInterns: 'Has assigned interns',
          noInterns: 'Has no assigned interns',
        },
        roles: {
          User: 'Supervisor',
          Manager: 'Manager',
          Admin: 'Administrator',
          Support: 'Support',
          None: 'No role',
        },
        columns: {
          user: 'User',
          firstName: 'First name',
          lastName: 'Last name',
          email: 'Email',
          phone: 'Phone',
          internCount: 'Assigned interns',
          unratedCount: 'Unrated records',
          lastLogin: 'Last login',
          actions: 'Actions',
          role: 'Role',
          state: 'Status',
          invitedBy: 'Invited by',
          createdUtc: 'Sent',
          validTill: 'Valid until',
        },
        actions: {
          resetPassword: 'Reset password',
          remove: 'Remove from organization',
        },
        actionSuccess: {
          resetPassword: 'Password reset and sent by email',
          remove: 'User removed from the organization',
        },
        tabs: {
          label: 'User sections',
          users: 'Users',
          invites: 'Invitations',
        },
        invitesEmpty: 'No invitations',
        inviteStates: {
          Pending: 'Awaiting response',
          Expired: 'Expired',
        },
        inviteActions: {
          cancelInvite: 'Withdraw invitation',
          deleteInvite: 'Delete',
        },
        inviteActionSuccess: {
          cancelInvite: 'Invitation withdrawn',
          deleteInvite: 'Invitation deleted',
        },
        confirmCancelInvite:
          'Withdraw the invitation sent to {{email}}? The link in the email will stop working.',
        confirmDeleteInvite: 'Delete the expired invitation for {{email}} from the list?',
        actionFailed: 'The action could not be completed',
        validation: {
          firstName: 'Enter a first name',
          lastName: 'Enter a last name',
          email: 'Enter a valid email address',
        },
      },
      internalEmails: {
        title: 'Email management',
        search: 'Search emails…',
        searchButton: 'Search',
        clear: 'Clear',
        deleteAll: 'Delete all emails',
        confirmDeleteAll: 'Permanently delete all intercepted emails?',
        confirmDelete: 'Delete the email “{{subject}}”?',
        confirmSend: 'Resend the email to {{email}}?',
        targetEmail: 'Recipient email',
        invalidEmail: 'Enter a valid email address',
        previewTitle: 'Email preview',
        sent: 'Email sent',
        deleted: 'Email deleted',
        deletedAll: 'All emails deleted',
        empty: 'No emails found',
        pageSize: 'Emails per page',
        range: 'Showing {{from}}–{{to}} of {{total}}',
        columns: {
          email: 'Email',
          subject: 'Subject',
          date: 'Date',
          actions: 'Actions',
        },
        actions: {
          view: 'Preview',
          send: 'Send to original recipient',
          sendTo: 'Send to…',
          delete: 'Delete',
        },
      },
      notFound: {
        title: 'Page not found',
        description: 'The requested page does not exist or has been moved.',
        backHome: 'Back to home',
      },
      technicalSupport: {
        menuItem: 'Technical support',
        title: 'Technical support',
        intro: "If something doesn't work or isn't clear — write to us.",
        emailLabel: 'Email',
        emailHours: 'Weekdays 9:00–17:00',
        phoneLabel: 'Phone',
        billingLabel: 'Invoices and licenses',
        includeTitle: 'What to include in your email',
        whatYouDidLabel: 'What you did',
        whatYouDidValue: 'Which section you were in and what you clicked',
        whatHappenedLabel: 'What happened',
        whatHappenedValue: 'What you saw on screen, not what you expected',
        screenshotLabel: 'Screenshot',
        screenshotValue: 'Very helpful — attach one if you can',
        phoneHintLabel: 'Phone',
        phoneHintValue:
          "Include your number — if anything is unclear, we'll call you and the issue gets resolved faster",
        close: 'Close',
        writeToSupport: 'Write to support',
      },
    },
  },
} as const

const initialLanguage = getInitialLanguage()
setDocumentLanguage(initialLanguage)
i18n.on('languageChanged', (language) => {
  const normalizedLanguage = normalizeLanguage(language)
  if (normalizedLanguage) {
    setDocumentLanguage(normalizedLanguage)
  }
})

void i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})
